import { WarningOrError } from '../../create-request/models/shared/WarningOrError';
import { AmountType, InstructionStatusCd, MediaTypeCd, TransactionType } from '../types/Transaction';
export const Constants = {
  toAccount401k: 'Unable to make request online. Please contact your service team.',
  toAccountEightDigitMsg: 'Please enter the 8 digit Schwab account number.',
  toAccountWrongDigitsMsg: 'Please enter a valid Schwab account number.',
  toAccountIncorrect: 'TO ACCOUNT number not found. Please correct the TO ACCOUNT number or cancel transaction.',
  abaNumber: 'ABA number',
  irsAbaNumber: 'Taxpayer name',
  toAccountInfoUnavailable: 'Receiving account information unavailable, as account is not managed by your firm.',
  atpReturnLimitMessage: 'The maximum number of transactions have been displayed. If you need to see more records contact your service team.',
  atpSaReturnLimitMessage: 'The maximum number of standing authorizations have been displayed. If you need to see more records contact your service team.',
  optionalDisplayText: '(optional)',
  minAccountNumberLength: 8,
  maxAccountNumberLength: 9,
  palAccountNumberLength: 12,
  toAccountInputLength: 9,
  toAccountMaxInputLength: 10,
  abaLength: 9,
  beneficiaryAccountNumberMaxLength: 34,
  clientAuthText: '<strong>The following recipients do not require additional authorization:</strong><br>',
  futureDatedWireMaxDays: 90,
  nextBusinessDayCopy: 'Every effort is made to process internal transfers received by 2:00 p.m. ET on the same business day. '
    + 'Actual processing time may vary based on receipt of authorization. Transaction dates default to the next business day '
    + 'if entered after the 2:00 p.m. ET cutoff.',
  createRequestServiceError: 'Unable to process your request online. Please download the form and submit via Docusign.',
  reviewPageCopy: 'Before submitting this transaction, please carefully review all details and, if needed, make a client authorization selection.',
  reviewPageSACopy: 'Please carefully review and confirm the information you\'ve provided, then select Submit.',
  confirmationPagePrefilledText: 'A prefilled authorization form has been generated for your client to sign.',
  reviewPageCopyClientAuthNeeded: 'A prefilled authorization form will be generated for your client to sign - this transaction is not eligible for eAuthorization.',
  processDateLabel: 'Process date',
  endDateLabel: 'End date',
  secondProcessDateLabel: '2nd Process date',
  secondCompletionDateLabel: '2nd Completion Date',
  secondWithdrawlDateLabel: '2nd withdrawal date',
  validationDateRequiredError: 'Valid Process Date required for this transaction.'
    + 'Please enter month, day and year in format: MM/DD/YYYY.',
  withdrawalDateLabel: 'Withdrawal date',
  validationPastDateError: 'Process date cannot be in the past. Please revise.',
  moneyMovementAcknowledgeText: 'Distributions present significant fraud risk to investment advisors, account holders, and custodians. By submitting this money '
    + 'movement instruction, you confirm that your firm has verified this instruction with your client. You and your firm understand and agree that Schwab will rely '
    + 'on any instructions you provide and Schwab is not responsible for any resulting loss if your firm did not verify the instruction with your client.',
  moneyMovementAcknowledgeNote: 'Note: Unsecure email is not an acceptable channel for verification. (1020-0GW9)',
  genericServiceError:
    'Service for this functionality is not available at this time. '
    + 'Please try again later or contact your service team.',
  initiateAndReleaseDuplicateDraftError: 'Transaction locked by another user',
  initReleaseAlreadyReleasedError: 'Target draft has already been released',
  wiresRegTypeError: 'Selected account type is not supported for Wire transactions',
  positionTableUserInputError: 'Please resolve any errors in position table before proceeding.',
  eauthServiceError: 'Electronic authorization is not available at this time. Please try again later or submit and print the authorization form.',
  taxWithholdingText: 'If you make any changes to the tax withholding elections on file for this account, you represent and warrant that you have permission and authority to designate your client\'s elections and understand the tax consequences.',
  moneyMovementAcknowledgeError: 'Please review and acknowledge your agreement by checking the box.',
  retirementStateTaxAttentionRequiredTextMA: 'Your client’s resident state of Massachusetts requires 9% state tax withholding if the total retirement account distributions for the year exceeds $1,107,750.',
  retirementStateTaxAttentionRequiredTextMS: 'Your resident state of Mississippi requires state income tax to be withheld on early and excess retirement account distributions. We recommend that you contact your tax advisor regarding your tax withholding election.',
  toAccountValidationError: 'Transfers into this account type are not supported in the current Move Money release.',
  palAccountValidationError: 'The account type is ineligible for creating a standing authorization.',
  achCTWEAuthorizationError: 'Updating tax withholding elections below the required minimums will require client authorization and cannot be done in this workflow. Please either readjust the withholding, or ',
  achCTWEShortenedResponseText: 'Updating tax withholding elections below the minimums will require client authorization and cannot be done in this workflow.',
  achAuthorizationErrorHeader: 'This request requires client authorization and cannot be done in this workflow.  Use our account maintenance workflow to ',
  recipentError: 'Recipient account not supported for online requests. Please contact your service team for assistance.',
  moneyMovementAcknowledgeErrorSummary: 'Please review and acknowledge your agreement to continue',
  taxCopyParagraphOne: 'If you make any changes to the tax withholding elections on file for this account, you represent and warrant that you have permission and authority to designate your client’s elections and understand the tax consequences.',
  taxCopyParagraphTwo: 'Distributions from IRAs (excluding Qualified Distributions from Roth IRAs) are generally subject to federal (and possibly state) income tax. Even if your client elects not to have federal and/or state income tax withheld, your client is liable for payment of federal income tax and state taxes, if applicable, on the taxable portion of his or her distribution. State tax displayed is for state of client\'s legal address.',
  expectedWithdrawalDateCopy: 'Expected withdrawal date shown is based on the completion date you enter and Schwab\'s established cutoff time of 5:30 p.m. ET.',
  fundsAvailableToTrade: 'Actual availability of funds may vary based on the transaction\'s risk characteristics.',
  createRequestAccessDeniedText: 'You are not currently able to create a new request in Move Money based on your permissions. If you believe this is incorrect, or to access additional functionality, please contact the Firm Security Administrator at your company.',
  onetimeAchNonRothIRA: 'IRA distributions set before the 5th of the month may be reported for the previous tax year, impacting the client’s Form 1099-R. To ensure January distributions are reported in the same tax year as the calendar year, set up the distribution for the 5th day of the month or later.',
  recurringAchNonRothIRA: 'Recurring IRA distributions set before the 5th of the month may cause January distributions to be reported for the previous tax year, impacting the client\'s Form 1099-R. To ensure January distributions are reported in the same tax year as the calendar year, schedule IRA distributions for the 5th day of the month or later.',
  journalThirdParty: 'Journal - 3rd Party',
  journalFirstParty: 'Journal - 1st Party',
  checkThirdParty: 'Check - 3rd Party',
  checkFirstParty: 'Check - 1st Party',
  checkLastBizDay: 'LASTBIZ',
  zeroPercent: '0%',
  oneHundredPercent: '100%',
  iraContributionTypeCopy: 'Note: If a distribution reason is not on the drop-down list, it is not available for online requests.',
  twePopupParagraphTwo: 'Select Confirm to apply this change to the account\'s tax withholding elections or select Cancel to close this window and return to the previous screen.',
  tweCalculatorFedTaxPrompt: 'Federal tax value is rounded to the nearest whole percentage.',
  tweCalculatorFedTaxNetWarning: 'Federal tax percentage changes affect the state tax dollars withheld. The review page reflects the final withholding amount.',
  tweCalculatorStateTaxNetWarning: 'State tax percentage changes affect the federal tax dollars withheld. The review page reflects the final withholding amount.',
  belowMinimumsErrorText: 'Please adjust the withholding or create a transaction with this withholding for client authorization.',
  ineligibleEAuthorizationDetailsCopy: 'A prefilled authorization form will be generated for your client to sign - this transaction is not eligible for eAuthorization.',
  digitalToPdfIneligibleEAuthorizationCopy: 'Standing authorizations from this type of account are not eligible for eAuthorization. We\'ll generate a prefilled authorization form for your client to sign once you submit this request.',
  availableCash: 'Available cash reflects funds, less margin, available for use today, and does not withhold funds for open trade orders.',
  contributionYTD: 'Contribution year-to-date (YTD) shows the amount put into Traditional IRA, Roth IRA, or Education Savings Accounts. It includes only personal contributions and does not include employer contributions.',
  unsettledCash: 'Cash that is still in the settlement process following the sale of an investment can\'t be transferred until settlement is complete. Once settled, it will be added to the Available cash balance.',
  tdaIraDistributionWarning: 'Only IRA distributions taken through Schwab are shown here. You can view earlier distributions taken through TD Ameritrade in Veo One, and your client can see them on their TD Ameritrade statements.',
  tdaIraContributionWarning: 'Only IRA contributions made through Schwab are shown here. You can view earlier contributions made through TD Ameritrade in Veo One, and your client can see them on their TD Ameritrade statements.',
  palOutstandingLoansTooltip: 'The principal amount owed to Schwab Bank.',
  palAvailableCreditTooltip: 'Maximum amount the client can withdraw.',
  palCreditLineTooltip: 'Maximum amount Schwab Bank may extend to the borrower.',
  palFinanceChargesTooltip: 'Interest charges due with the next payment.',
  palTotalPaymentDueTooltip: 'Finance charges due with the next payment, plus any past-due payments and late fees.',
  contributionYear: `Note: If a contribution type is not on the drop-down list, it is not available for online requests

  IRA Contribution Types unavailable for online requests:

  • Simple Employer
  • Simple Salary Deferred
  • Transfer
  • QRP Contributions`,
  withdrawalDateErrorMessage: 'Withdrawal date can\'t be retrieved, please use a different completion date',
  trustIncomePercentToolTip: 'TBD',
  trustPrincipalPercentToolTip: 'TBD',
  beneficiaryAccountNumberMissing: 'Please add account number',
  nraText: 'The federal tax will be withheld at the prevailing treaty rate (up to 30%) for eligible non-resident foreign clients and will be confirmed at the Review step.',
  principalPercentageOnly: 'This account is "Principal Only"',
  wireTransmissionNotes: 'Include important information for the receiving or intermediary bank(s) handling the wire: contact names, the purpose of the funds, or other details that might be necessary.',
  irsAbaWireTransmissionNotes: 'Enter any additional information that may be required, such as interest and penalty details. Go to www.irs.gov to check formatting requirements.',
  loaNeeded: 'Obtain a client signature through Docusign. We\'ll continue processing this transaction once we’ve received client authorization.',
  eauthNeeded: 'We sent an eAuthorization notification to your client(s) to approve in Schwab Alliance—and if they need to enroll, we included instructions. We\'ll continue processing this transaction once we’ve received client authorization.',
  saLoaNeeded: 'Please upload a signed authorization through Docusign. We\'ll continue processing this request once we’ve received client authorization.',
  saEauthNeeded: 'We sent an eAuthorization notification to your client(s) to approve in Schwab Alliance—and if they need to enroll, we included instructions. We\'ll continue processing this standing authorization once we’ve received client authorization.',
  defaultPendDescription: 'Your transaction was received and is in process. You can view its status in the Account Transactions table in Move Money.',
  defaultSaPendDescription: 'Your transaction was received and is in process.',
  wireProcessDateToolTip: 'Wires will be processed on the same business day on a best efforts basis if received by 2:30pm EST, and client eAuthorization is received by 4:30pm EST. When entering a transaction on Move Money, the Process Date will default to the next business day if entered after the 2:30pm EST cutoff time.',
  departmentTooltip: 'Attention: Accounts Payable',
  intlStateToolTip: 'Subdivision of a country.',
  districtTooltip: 'Further subdivision of a state, province, or region. Also known as a county or urbanización.',
  intlSublocalityToolTip: 'A specific location name within a city, town, or locality. Also known as a village or borough.',
  wireIntlProcessDateToolTip: `Requests for future-dated wires or international wires that do not have a standing authorization (SLOA) on file cannot be processed electronically at this time. We'll create a prefilled form with the transaction details you enter here that you can upload through Docusign.

• Wiring funds outside of the U.S. may take up to 7 business days. Funds must be available in the account on the process date.

• If you're requesting an international wire to be sent on a future date, the exchange rate won't be known until Schwab executes the transaction on the process date. Taxes and other fees may apply.

• If Schwab doesn't receive the letter of authorization (LOA) in good order before the requested process date, the wire will be processed after Schwab receives that LOA.`,
  checkProcessDateToolTip: 'Every effort is made to process checks received by 2:00 p.m. ET on the same business day. Actual processing time may vary based on receipt of authorization. Transaction dates default to the next business day if entered after the 2:00 p.m. ET cutoff.',
  checkProcessDateReviewCopy: 'Every effort is made to process and mail checks on the same business day if requested by 2:00 p.m. ET for Standard delivery or by 1:00 p.m. ET for Overnight delivery. '
    + 'Processing dates default to the next business day if requests are made after these cutoff times, and actual processing time may vary based on the receipt of authorization.',
  wireAchDistributionReasonTooltip: `If a distribution reason is not on the drop-down list, it is not available for online requests.

  Distribution Reasons unavailable for online requests:

  • Beneficiary (4M) - Educational Savings Distribution

  • Direct Rollover (Code G)

  • Excess (Code 8 and P)

  • Prior Year RMD`,
  itCheckDistributionReasonTooltip: `If a distribution reason is not on the drop-down list, it is not available for online requests.

  Distribution Reasons unavailable for online requests:
  •   Direct Rollover (Code G)
  •   Excess (Code 8, P, 8J, and PJ)
  •   Recharacterization (Code N and R)`,
  qcdDistributionReasonTooltip: '<div><br>Notes on Qualified Charitable Distributions (codes 7-QCD and Y4)<br></div><div>•   You are responsible for confirming your client’s eligibility and ensuring transaction details satisfy all QCD requirements under <a target="_blank" href="https://www.irs.gov/publications/p590b"><div class="tooltip-link">IRC Section 408(d)(8).</div></a></div><div>•   For reporting purposes, mail the check to your client’s address of record or to your firm office as needed.</div><div>•   7-QCD will reflect on the 1099-R starting in 2026 as Y7.</div>',
  rmdAlertText: `Select "NORMAL (7)" distribution reason for one-time transactions. If you select "RMD (7-RMD)" for Schwab to automatically calculate and set up a recurring distribution:
  •   The start date you enter must fall within the next calendar year.
  •   The amount must be entered as $0.00.
  •   The amount and tax withholding elections will be calculated at the end of this calendar year.`,
  wireReviewPageDisclaimer: 'Every effort is made to process wires on the same business day if received by 2:30 p.m. ET and client eAuthorization is received by 4:30 p.m. ET. Process dates default to the next business day if entered after the 2:30 p.m. ET cutoff.',
  wireFirstParty: 'First party',
  wireThirdParty: 'Third party',
  wireThirdPartyEscrow: 'Third party—Escrow/title company',
  wireIntermediaryAddressHint: 'Must include city and state.',
  eAuthorizationDescription: 'eAuthorization is recommended because it offers greater security against fraud and faster processing times than paper-based transactions.',
  schwabAllianceDescription: 'Schwab Alliance is a version of the schwab.com website and mobile app customized specifically for clients of advisors. Once clients have enrolled, they can electronically authorize transactions, make account changes, and access documents—quickly and securely.',
  distributionReasonToolTipText: 'If you would like to have the required distribution amount for a future year calculated and scheduled for you, please enter $0 at this time. At the beginning of the specified year, the RMD amount will be calculated and populated for these distributions. If you would like to designate a specific withdraw amount, please select \'Normal\' for your Distribution Type instead.',
  trustReceivingAccountCopy: 'Note: The To account is subscribed to Schwab\'s Personal Trust Reporting Service and, accordingly, Principal and Income designation as well as tax codes can be assigned to this transaction.',
  payeeNameMissing: 'Please enter a valid name',
  overnightCheckCopy: 'Overnight (next business day) delivery is available for domestic (U.S.) addresses only. For international delivery, PO boxes, Military Mail (APO, FPO, DPO), tracking information, or other requests, please contact your Service Team.',
  overnightCheckBanner: 'Overnight delivery is not available for Move Money transactions with international addresses, P.O. boxes, or military addresses (APO, FPO, DPO). To continue in Move Money with this transaction, select standard mail. You can also contact your Service Team to process the transaction with overnight delivery.',
  clientEmailTooltipText: 'Submit this client\'s email address and we’ll send instructions to enroll in Alliance so they can eAuthorize transactions.',
  escrowOrTitleCompanyWarningTitle: 'Be aware of fraud risks:',
  escrowOrTitleCompanyWarningDescription:
    `  •   Transactions involving escrow or title companies are frequently targeted by bad actors, so watch for red flags.
  •   Be sure your client has directly contacted the escrow or title company to verify detailed wire instructions.
  •   Only use contact and account information that's already known by your client—never rely solely on information provided via email.`,
  optionalWireDetailsBannerDescription: 'Avoid duplicate or immaterial transmission notes in wire instructions to prevent processing delays.',
  recipientAddressWireBannerDescription: 'Provide the full street address, including recommended fields, to reduce the risk of wire delay.',
  receivingAbaAccountNumberWarningDescription: 'Recheck the receiving account number, since it is identical to the receiving bank ABA number.',
  intermediaryAbaAccountNumberWarningDescription: 'Recheck the intermediary account number, since it is identical to the intermediary bank ABA number.',
  checkDepositRelativeUrl: '../../../si2/ui/deposit/',
  importTransactionMfeUrl: '../../../SI2/Home/interop/ImportTransactions.aspx',
  accountManagementRelative: '../../../SI2/Home/Utilities/AccountManagement.aspx',
  digitalToPdfPrimaryConfirmationPageText: 'We\'ve generated a prefilled authorization form for your client to sign.',
  digitalToPdfPrimaryEauthText: 'You can proceed by selecting Create PDF. We\'ll generate a prefilled authorization form for your client to sign.',
  totalDistributionD2PEauthText: 'You can proceed with this transaction by selecting Create PDF. We\'ll generate a prefilled authorization form for your client to sign.',
  ineligibleForEauthText: 'No account holders are eligible for eAuthorization at this time',
  ineligibleForEauthPrimaryText: 'You can proceed by selecting Submit. We’ll generate a prefilled authorization form for your client to sign.',
  accountIneligibleForEauthSecondaryText: 'This account type is ineligible for eAuthorization',
  accountIneligibleNoAccountHoldersForEauthSecondaryText: 'No account holders are eligible for eAuthorization at this time',
  addressSecondLineGreyText: 'Must include city and state/province.',
  intermediaryRequiredMessage: 'ABA number entered requires a corresponding bank or institution.',
  transmissionNotesCharLimit: '280',
  transmissionNotesTaxRemittanceLimit: '140',
  authorizationNicknameCharLimit: '50',
  zeroAmount: '$0.00',
  intermediaryBankIdType: 'Bank ID: ',
  oneTimeCheck100PercentTWEInfo: 'The tax withholding elections entered will only apply to this transaction - they will not become the account\'s default going forward.',
  connecticutVerifyMessage: 'Your client\'s state of residency (Connecticut) requires a new W4P form if state tax withholding is changed to 0%. Visit portal.ct.gov/drs to download the form or contact the state tax authority for information.',
  michiganVerifyMessage: 'Your client\'s state of residency (Michigan) requires a new W4P form if state tax withholding is changed to 0%. Visit <a href=\'https://www.michigan.gov/taxes\'>michigan.gov/taxes </a> to download the form or contact the state tax authority for information.',
  minnesotaVerifyMessage: 'Your client\'s state of residency (Minnesota) requires a new WMNP form if state tax withholding is changed to 0%. Visit the state government website or to download the form or contact the state tax authority for information.',
  clientAuthSignatureForm: 'This transaction will require client authorization.  Please either select an eAuthorization approver or download a prefilled authorization form.',
  atpRequestTimeoutErrorMessage: 'Due to a system error, we were unable to confirm this transaction, and the request was cancelled. Please resubmit the transaction.',
  atpRequestTimeoutErrorMessageInR: 'Due to a system error, we were unable to confirm this transaction at this time, and the request was cancelled. Please release the transaction again.',
  atpRequestTimeoutErrorDetail: 'The ATP wire confirmation step has timed out',
  atpRequestSloaFailedToggleOnSubmit: 'Your standing authorization may have processed successfully, but we cannot load a confirmation. Please confirm the status on the Move Money page or contact your service team for assistance.',
  atpRequestOneTimeFailedToggleOnSubmit: 'Your submission may have processed successfully, but we cannot load a confirmation. Please confirm the status on the Move Money page or contact your service team for assistance.',
  atpErrorOnSubmitToggleOnBannerTitleText: 'We couldn\'t verify your submission.',
  atpErrorOnSubmitToggleOnBannerMessage: 'Our verification service is temporarily unavailable. Return to Move Money and check the account history or standing authorization tables to verify your submissions. For additional help, please contact your service team.',
  allTransactionsPaginationDisclaimer: 'Includes past transactions for the last 30 days up to a limited number of transactions. Recurring transactions show the next occurrence within the next 15 days. Upcoming one-time transactions are displayed up to a limited number of transactions.',
  upcomingPaginationDisclaimer: 'Recurring transactions show the next occurrence within the next 15 days. Upcoming one-time transactions are displayed up to a limited number of transactions.',
  initReleasePaginationDisclaimer: 'Released transactions can be found in the Account transaction table',
  createRulePaginationDisclaimer: 'How do conflicting rules work?',
  createRuleTooltipPopupMessage: 'If the same transaction type, party or authorization is covered by multiple rules, the lower dollar amount threshold will apply.',
  recentPaginationDisclaimer: 'Includes past transactions for the last 30 days up to a limited number of transactions.',
  transactionStatusPaginationDisclaimer: 'Includes past transactions for the last 30 days up to a limited number of transactions. Recurring transactions show the next occurrence within the next 15 days. Upcoming one-time transactions are displayed up to a limited number of transactions. Standing Authorizations in Pending status are displayed.',
  viewPagePtrsInfoBannerPrimaryText: 'Any income and principal percentages, trust tax codes, or comments shown here may not reflect recent adjustments. For the most current information, view the latest transactions in ',
  viewPagePtrsInfoBannerBoldText: 'Accounts > Transactions > Trust Transactions.',
  wireHighDollarAmountWarningText: 'Be on alert for red flags that could signal a wire fraud scam.\n'
    + 'DO NOT call your client through information you received via email, because bad actors often use unsecure channels like email for attempts at fraud.\n'
    + 'Ensure your client has contacted the beneficiary on this transaction to verbally validate the detailed wire instructions.\n'
    + 'Before completing the transaction, be sure you have verbally discussed it with your client.',
  wireHighDollarAmount: 200000,
  thirdAddresseeNameInfoText: 'The third addressee name will not appear on mailing label when overnight is selected.',
  createSaThirdAddresseeNameInfoText: 'When creating your check request, the third addressee name will not appear on mailing labels when overnight delivery method is selected.',
  toastrMessageEmployee: 'Action not permitted for employee-user.',
  toastrMessageDemoUser: 'This action cannot be completed on the demo site.',
  futureDatedSufficientFundsWarning: 'Sufficient funds must be settled in the account the day prior to the Process date for future-dated wires to avoid wire cancellation.',
  wireTemplateConfirmationText: 'We saved these wire details in a template for future use. You can find the saved wire template in the Account transactions table.',
  newRecurringAchProfileConfirmation: 'Your recurring transaction was received. You can view it in the Standing Authorizations table',
  newOnRequestAchProfileConfirmation: 'We have also saved an on-request standing authorization for future use.',
  onRequestAchProfileCreationFailed: 'We were unable to complete this transaction, as the profile was unable to be created.',
  achContributionLimitExceeded: 'CONTRIBUTION AMOUNT EXCEEDS MAXIMUM LIMIT',
  newOnRequestProfileCreated: 'On-Request profile created',
  newOnRequestProfileRemoved: 'On-Request profile removed',
  minStateTaxWithholdingError: 'State tax does not meet minimum withholding requirement.',
  minStateTaxErrorMessageCode: '8699',
  openOrdersMessage: 'Please be advised there are open trade orders on this account.',
  securityFundsAlertMessage: 'Funds or securities moved into this managed account will be sold and invested.',
  marginLoanDisbursement: 'Margin debit amount will be created or increased with this request.',
  earlySimpleIra: 'Use distribution code (S) for distributions from a SIMPLE IRA taken within two years of the date of the first contribution and if the taxpayer has not reached age 59 1/2.',
  positionsTaxImplicationDisclaimer: 'If taxes are withheld, the Federal Tax, State Tax, and Cash Withdrawal Amounts will also be updated when request is completed. Federal and State Taxes are calculated using the gross cash and position values. You can view the information on your monthly statement.',
  completionDateLabel: 'Completion date',
  defaultMaxDate: '12-31-9999',
  jointPayeeBannerText: 'All account holders must be included in the new modified registration. Pending name edits require approval by Schwab prior to processing the transaction.',
  editTweNoUpdate: 'No changes have been made to the tax withholding elections.',
  editTweError: 'We could not process your changes to tax withholding elections at this time. Please try again.',
  editTweSuccess: 'Tax withholding elections have been updated successfully.',
  editTweStateTaxRequiredWhenFedWithheldServiceError: 'STATE TAX REQUIRED WHEN FEDERAL TAX IS WITHHELD.',
  editTweErrorStateTaxRequiredWithFedWithholdingMessage: 'If you have federal income tax withheld, Schwab is required to withhold state income tax.',
  createBundledSaMessaging: 'A bundled standing authorization allows your end-client to authorize the IA to direct third-party money movements from their accounts.',
  intermediaryTooltip: 'An intermediary may be used by a bank working with a larger bank or brokerage firm, an internal department within a bank (such as a loan servicing or trusts), or a general ledger or clearing account. Do not add an escrow/title company or loan information as an intermediary - this information should simply be entered within the appropriate third-party recipient fields.',
  intermediaryHeader: 'Intermediary',
  receivingBankDetailsHeader: 'Receiving bank details',
  intermediaryDetailsHeader: 'Intermediary details',
  intermediaryNameAddressSubHeader: 'Intermediary name and address',
  secondaryIntermediaryNameAddressSubHeader: 'Second Intermediary',
  thirdIntermediaryNameAddressSubHeader: 'Third Intermediary',
  intermediaryNameAddressUseSloaSubHeader: 'Recipient bank',
  modifiedPayeeTooltipVerbiage: 'Allows the original payee\'s name to be revised for first-party wires, first-party checks, one-time/recurring transactions, and standing authorizations.',
  missingViewMoveMoneyPrimary: 'You are not currently able to view information in Move Money based on your permissions.',
  missingViewMoveMoneySecondary: 'If you believe this is incorrect, or to access additional functionality, please contact the Firm Security Administrator at your company.',
  blockTradingAccountPrimary: 'You can only view existing transactions and standing authorizations with your access.',
  blockTradingAccountSecondary: 'You cannot initiate Move Money transactions using a block trading master account.',
  abaIntermediaryBankLabel: 'Intermediary bank ABA number',
  abaReceivingBankLabel: 'Receiving bank ABA number',
  ADVISOR_CENTER_URN: 'urn:schwab:comsec:1.0:entity:AdvisorCenter',
  iraRolloverLabel: 'ROLLOVER',
  iraRolloverContributionTypeWarning: '<div><b>Transaction subject to a 60-day rollover period</b></div><div>This is required whenever position(s) and/or cash are transferred to an IRA account. To complete a valid 60-day rollover, the IRS requires the same asset(s) (positions and/or cash) to be returned as it was received from the distribution.</div>',
  iraRolloverContributionTypeWarningforMultiple: '<div><b>Transaction(s) subject to a 60-day rollover period</b></div><div>This is required whenever position(s) and/or cash are transferred to an IRA account. To complete a valid 60-day rollover, the IRS requires the same asset(s) (positions and/or cash) to be returned as it was received from the distribution.</div>',
  transactionFailedButTweSubmitted: 'Transaction failed to process but the TWE was updated. Please review required TWE when submitting a new transaction request',
  qcdDistributionInformation: 'The zero percent tax withholding elections applied for this QCD distribution will only apply to this transaction and will not impact your account-level settings or future transactions.',
  trustCommentWarningBannerText: 'Additional transaction comments may be made only by the Trustee or IA and will be displayed on schwabadvisorcenter.com, the trust report, the combined brokerage statement and trust report, or other presentations of data (the “Trustee/IA Transaction Comments”). Trustee/IA Transaction Comments should be limited to a brief description of the transaction and should not contain personal information (“PI”), non-public information (“NPI”) or inappropriate language. Trustee/IA Transaction Comments are the sole responsibility of the Trustee and IA and Schwab makes no warranties as to their accuracy or completeness. Schwab reserves the right to edit or remove Trustee/IA Transaction Comments.',
  initiateInRTransaction: 'Per your firm’s Initiate & Release rules, this transaction has been submitted for a releasor review before it will be submitted to Schwab for processing.',
  initiateInRSLOATransaction: 'Per your firm’s Initiate & Release rules, this standing authorization has been submitted for a releasor review before it will be submitted to Schwab for processing.',
  noActiveRuleHeader: 'There are no active rules',
  noActiveRuleMsg: 'No transactions are subject to initiate and release process until a custom rule has been created.',
  wireViewPageRetryWarning: 'We\'re currently unable to retrieve the status of this request. Please retry displaying this page',
  isoWireTemplateErrorBannerHeader: 'Update recipient address',
  isoWireTemplateErrorBannerHeaderIntermediary: 'Update intermediary address',
  isoCompliantWireTemplateErrorBannerHeader: 'Update bank address',
  isoWireTemplateErrorBannerDescriptionIntermediary: 'To remain compliant with industry standards, Schwab requires structured addresses for all banks. To proceed with this template and save it for future use, re-enter the address on file in the required fields.',
  isoWireTemplateErrorBannerDescriptionRecipient: 'To remain compliant with industry standards, Schwab requires structured addresses for wire recipients. To proceed with this template and save it for future use, re-enter the address on file in the required fields.',
  isoCompliantAddressErrorDescription: 'To comply with industry standards, Schwab requires structured addresses for wire recipients and intermediary accounts. Before submitting this wire, re-enter the address on file. We will save it for future use.',
  isoWireTemplateErrorBannerFooter: 'Address on file: ',
  achUpdatedInformationBannerTitle: 'One time transactions will submit using the existing On-Request profile and the following information has changed to match the On-Request profile',
  totalDistributionTooltip: 'When you select a total distribution, all cash and securities must be transferred.',
  reportsRequestedTooltip: 'All reports start from the first month under your management.',
  totalWithdrawalResponseMessage: 'Available Upon Completion of Journal',
  totalWithdrawalAmountInternalTransfer: 'Available upon completion of Internal Transfer',
  taxFormsText: 'We\'ll provide forms from the date you began managing this account through the end of the calendar year you specify here:',
  accountStatementstext: 'We\'ll provide statements from the date you began managing this account through the end of the month you specify here:',
  tradeConfirmationsText: 'We\'ll provide trade confirmations from the date you began managing this account through the date you specify here:',
  intermediaryISOTooltip: 'An intermediary may be used by a bank working with a larger bank or brokerage firm, an internal department within a bank (such as a loan servicing or trusts), or a general ledger or clearing account. Do not add an intermediary for entering the escrow/title company or loan information - this information should be entered within the "third-party recipient" section.',
  recipientBankTooltip: 'Funds move through this account before being deposited into the recipient’s account. Loan information should not be entered here because the escrow/title company would be the third-party recipient.',
  checksTotalDistributionAmountText: 'Will distribute total cash balance',
  mmIneligibleAccountPageHeader: 'Ineligible account type',
  checksTotalWithdrawalAmountText: 'To be determined after tax deduction',
  invalidTransactionInitiateAndRelease: 'Transaction is invalid and cannot be released. Please re-enter the transaction.',
  invalidStandingAuthorizationInitiateAndRelease: 'Standing authorization is invalid and cannot be released. Please re-enter the standing authorization.',
  transactionTypeNotSupported: 'This transaction is not supported for this account type.',
  transactionTypeUnauthorized: 'Contact your firm security administrator for permission to use the transaction type.',
  transactionUnauthorized: 'You don’t have permission to create transactions. To request permission, contact your Firm Security Administrator.',
  ptrsUnauthorized: 'You do not have access to Personal Trust Reporting Service accounts. To request permission, contact your Firm Security Administrator.',
  accountIneligible: 'This account type is ineligible for digital transaction creation. To create new transaction, submit the relevant forms from the <a target="_blank" href="https://si2.schwabinstitutional.com/SI2/Home/Utilities/AccountManagement.aspx">Forms Library</a>',
  accountTypeIneligibleForEauth: 'This account type is ineligible for eAuthorization. We\'ll generate a prefilled authorization form for your client to sign once you submit this request.',
  submit401kSeparatelyError: 'i401K and Roth i401K account transfers must be submitted individually and cannot be submitted as part of multi-account transfers. Remove account and enter it separately later.',
  selectLotsManually401kDisabled: 'Select lots manually (This cannot be selected for contributions into i401k or Roth i401k.)',
  wireIrsTooltip:
  '<div>Go to the <a href="https://www.irs.gov/payments/same-day-wire-federal-tax-payments">IRS website</a> to access the same-day taxpayer worksheet for help identifying the applicable tax type code, year, and month for the wire payment.</div>',
  y4StandingAuthErrorMessage: 'This standing authorization cannot be used at this time. Please try again later.',
  federalReferenceNumber: 'Federal Reference Number',
  pending: 'Pending',
  federalReferenceNumberDisclaimer: 'The Federal Reference Number will be populated once the transaction is authorized (if required) and the wire is processed.',
  palTransactionInfoBannerText: 'Wires are currently the only available transaction option for this account type. Standing authorizations are not available.',
  achFundsSettlementBannerText : 'Available funds need to fully settle by the expected withdrawal date.'
};

export const distributionReasons = {
  normal: 'NORMAL (7)',
  rmd: 'RMD (7-RMD)',
  qcd: 'QCD (7-QCD)',
  qcdY4: 'QCD (Y4)',
  qcdY4Code: 'Y4',
  qualified: 'QUALIFIED (Q)',
  exceptionApplies: 'EXCEPTION APPLIES (T)',
  early: 'EARLY (1)'
};

export const RegTypeCode = {
  ROTH_401K: 'RI401',
  INDIVIDUAL_401K: 'I401K',
  GUARDIANSHIP: 'GU',
  CONVERSATORSHIP: 'CONS',
  CUSTODIAL: 'CU'
};

export const FullRegTypeCode = {
  GUARDIANSHIP: 'Guardian',
  CONVERSATORSHIP: 'Conserv',
  CUSTODIAL: 'Cust',
  INDIVIDUAL_401K: 'I401(k)',
  ESTATE: 'Estate'
};

export const digitalRegTypes = ['CONSERV', 'ESTATE', 'GUARDIAN', 'TEST TRUST'];

export const IRARegTypeCodes: string[] = [
  'Roth Contrib',
  'Roth Conversion',
  'Cust Roth Cont',
  'Cust Roth Conv',
  'Roth SIMPLE IRA',
  'Roth SEP IRA',
  'Roth I401(k)',
  'Inh Roth',
  'Inh Roth QP',
  'Min Inh Roth',
  'Min Inh Roth QP'
];


export const tableActions = {
  startTransaction: 'Create transaction',
  viewStatus: 'View',
  viewDetails: 'View',
  edit: 'Edit',
  deleteProfile: 'Delete',
  deactivateProfile: 'Deactivate',
  reactivateProfile: 'Reactivate'
};

export const stateCodes = {
  CONNECTICUT: 'CT',
  MICHIGAN: 'MI',
  MINNESOTA: 'MN',
  Massachusetts: 'MA',
  Mississippi: 'MS',
};

export const stateTypeIndicators = {
  //These constants represent a special state vs a regular state returned from CMT/ATP
  //S is typically returned for MI,CT,MN NON-Roth IRA Accounts
  //Otherwise R is returned(ie. Most States/Reg Types)
  Special: 'S',
  Regular: 'R'
};

export const prettierWarnings = {
  clientAuth: 'Client Authorization Needed (LOA)',
  electronicAuth: 'Electronic Authorization Needed',
  clientAuthTax: 'Client Authorization Needed For Tax Elections',
  clientAuthNDFALPFA: 'Schwab is Reviewing for Client Auth due to NDFA/LPFA',
  clientAuthNonTax: 'Client Authorization Needed For NonTax Elections'
};

export const eAuthRestrictionResons = { noEmailOnRecord: 'There is no email address of record for this account holder. To add or edit an email address, please go to the Account Profiles page.' };

export const accountRestrictionReasons = { assetsPledged: 'ASSETS ARE PLEDGED' };

export type EAuthEligibility = 'Complete' | 'Email required' | 'Ineligible' | 'Awaiting Alliance setup';

export type ViewTypes = 'transaction' | 'standing-auth' | 'template' | '';

export type MasterViewTypes = 'master-standing-auth' | 'master-transaction' | 'recurring' | 'activity-report' | '';

export type PageTypes = 'review' | 'view' | '';

export type CustomerEauthStatuses = 'Decline' | 'Complete' | 'Pending' | 'Accept' | 'Expired';

export const eAuthNotifications = {
  emailSubmitSuccess: 'Schwab Alliance enrollment instructions have been sent to your client. They’ll be able to eAuthorize transactions once they’ve completed their Alliance setup.',
  emailSubmitFailed: 'Unable to submit the email address at this time. Please try again later.',
  sendAllianceInstructionsFailed: 'The email address has been accepted, but we were unable to send an email with the Alliance setup instructions. Please ask your client to access www.schwaballiance.com and select the New User link.',
  sendAllianceInstructionsFailedShort: 'We were unable to send an email with the Alliance setup instructions. Please ask your client to access www.schwaballiance.com and select the New User link.',
  inValidEAuthStandingAuth: 'This transaction requires client authorization from all account holders. Electronic Authorization is not valid because at least one account holder is ineligible.',
  missingEmailMessage: 'All account holders need to approve the standing authorization. Please add any missing email addresses in the eAuthorization setup above.',
  submitAndCreateIneligibleMessage: 'All clients must authorize the standing authorization, but at least one client is not eligible for electronic authorization. You can either submit a one-time request or change the client authorization method.',
  digitalToPdf: 'Please upload the prefilled PDF form through Docusign. We\'ll continue processing this transaction once we\'ve received client authorization.',
  requiringClientAuthorizationWarningMessage: 'Please upload a signed authorization through Docusign. We\'ll continue processing this transaction once we\'ve received your client\'s authorization.',
  submitPrefilledFormMessage: 'Your request has not been submitted. Please submit the prefilled form through Docusign. After submission, you can track the status of this request on the Accounts Activity tab.',
};

export const eAuthStatusStrings = {
  Approved: 'Authorization completed by',
  Declined: 'Authorization declined by',
  Pending: 'Awaiting authorization from',
  Expired: 'Authorization has expired for'
};

export const createStandingAuthMessage = {
  allAccountHolders: 'Select this option to create a new standing authorization for future use. If you are using eAuthorization, we\'ll send a separate approval email from the transaction approval. If not, we\'ll generate a combined prefilled authorization form for them to sign.',
  oneAccountHolder: 'Select this option to create a new standing authorization for future use. If you are using eAuthorization, we\'ll send a separate approval email from the transaction approval. If not, we\'ll generate a combined prefilled authorization form for them to sign.',
  orgTrustAccounts: 'Select this option to create a new standing authorization for future use. If you are using eAuthorization, we\'ll send a separate approval email from the transaction approval. If not, we\'ll generate a combined prefilled authorization form for them to sign.',
  bundledAccount: 'If you select this option, once you submit this transaction, Schwab will process your request and create a new bundled standing authorization for future use.'
};

export const confirmationStatusMessage = { onetimeTotalDistribution: 'Action required - Waiting for a Docusign submission with the prefilled form' };

export const Symbols = {
  bulletPoint: '\u2022',
  space: '\u00A0',
};

export const transactionTypesDict = {
  ach: 'ACH (MoneyLink)',
  'internal-transfer': 'Internal transfer (journal)',
  check: 'Check',
  wire: 'Wire',
  WireSloa: 'WireSloa'
};

export const Frequencies = {
  onetime: 'onetime',
  ONETIME: 'ONETIME',
  recurring: 'recurring',
  onRequest: 'ONREQST',
  onetimeTotalDist: 'One-time total distribution'
};

export const RecurringFrequencyCodes = {
  twiceMonthly: 'SEMIMTH',
  monthly: 'MONTHLY',
  lastBizDay: 'LASTBIZ',
  everyTwoMonths: 'BIMTHLY',
  quarterly: 'QURTRLY',
  semiAnnual: 'SEMIANN',
  annualy: 'ANNUALY',
  weeklyMon: 'WKLYMON',
  weeklyTues: 'WKLYTUE',
  weeklyWed: 'WKLYWED',
  weeklyThurs: 'WKLYTHU',
  weeklyFri: 'WKLYFRI'
};

export const NoRowsMessageTemplates = {
  wiresHeader: 'This account does not have any saved wire templates',
  wiresDetail: 'Save your wire details as a saved wire template to create future transactions quickly and easily.',
  transactionsHeader: 'No transactions on file',
  standingAuthHeader: 'No standing authorizations on file',
  bookmarks: 'No accounts have been bookmarked'
};

export type CheckPayeeTypes = 'First party (account holder)' | 'Third party';

export type CheckRecipientTypes = 'Account holder address' | 'Other U.S. address' | 'Advisory firm for this account' | 'Other International address';

export type CheckAbbreviatedRecipientTypes = 'firstParty' | 'thirdPartyDomestic' | 'advisoryFirm' | 'thirdPartyInternational';

export type CheckResponseRecipientTypes = 'addressofrecord' | 'addressdomestic' | 'addressforeign';

export type YesNo = 'yes' | 'no';

export type StringBoolean = 'true' | 'false';

export const checkPayeeDict = {
  firstParty: 'First party (account holder)',
  thirdParty: 'Third party'
};

export const payeeTypeDict = {
  firstParty: 'payeeofrecord',
  thirdParty: 'payeeothers'
};

export const recipientAddressTypeDict = {
  firstParty: 'addressofrecord',
  advisoryFirm: 'addressdomestic',
  thirdPartyDomestic: 'addressdomestic',
  thirdPartyInternational: 'addressforeign',
};

export const checkRecipientTypeDict = {
  addressofrecord: 'firstParty',
  addressdomestic: 'thirdPartyDomestic',
  addressforeign: 'thirdPartyInternational',
  // TODO: Figure out what is supposed to map to this
  //addressdomestic: 'advisoryFirm'
};

export const checkRecipientDict = {
  firstParty: 'Account holder address',
  thirdPartyDomestic: 'Other U.S. address',
  advisoryFirm: 'Advisory firm for this account',
  thirdPartyInternational: 'Other International address'
};

export const yesNo = {
  yes: 'yes' as YesNo,
  no: 'no' as YesNo
};

export const RothConversion = {
  DistributionReasons: {
    CONVERSION_SUB_CODE: 'CONV',
    COMBINATION_SUB_CODE: 'COMB',
    OVER_59_AND_A_HALF_CONVERSION_CODE: '7',
    UNDER_59_AND_A_HALF_CONVERSION_CODE: '2',
    COMBINATION_CONVERSION_CODE: '0',
    QUALIFIED_CODE: 'Q',
    QCD_SUB_CODE: 'QCD',
    QCD_DESCRIPTION: 'QCD (7-QCD)'
  }
};

export const RothWarnings = {
  under59InputWarning: 'Note: If your client is under 59.5 the money withheld for taxes can be subject to taxes and 10% penalty. Please reach out to the service team or your tax professional for questions.',
  over59InputWarning: 'Note: Though your client may not be subject to the 10% penality for the amount converted to the Roth IRA, the money withheld can be subject to taxes. Please reach out to the service team or your tax professional for questions.',
  verifyPageRothWarning: 'Under IRS rules, your client is required to satisfy the required minimum distribution before a Roth conversion can be completed. By submitting, you are confirming the RMD has been satisfied.',
  Comb0InputWarning: 'In accordance with federal regulations, Schwab will apply a zero percent federal and state tax withholding to IRA distributions when this distribution reason is used.',
  QualifiedDistributionWarning: 'In accordance with federal regulations, Schwab will apply a zero percent federal and state tax withholding to IRA distributions when this distribution reason is used.',
  QualifiedComb0InputDistributionWarning: 'In accordance with federal regulations, Schwab will apply a zero percent federal and state tax withholding to IRA distributions when \'0-Comb\' or \'Qualified\' distribution reason is used.',
  ZeroPercentWarning: 'Zero percent federal and state tax will be applied to the following receiving account(s):',
  ZeroPercentWarningBannerTitle: 'Zero percent federal and state tax will be applied to the following receiving account(s):'
};

export const frequencyDict = {
  onetime: 'One-time',
  onetimeTotalDist: 'One-time total distribution',
  recurring: 'Recurring'
};

export type FrequencyTypes = 'One-Time' | 'Recurring';

export const enum transactionTypes {
  ach = 'ach',
  internalTransfer = 'internal-transfer',
  check = 'check',
  wire = 'wire',
  wireSloa = 'WireSloa'
}


export const enum frequencyTypes {
  onetime = 'One-Time',
  recurring = 'Recurring'
}

export const pendReasonsStrings = {
  clientAuthEauth: 'Electronic Authorization Needed',
  clientAuthLOA: 'Client Authorization Needed (LOA)',
  ndfaLPFA: 'Schwab is Reviewing for Client Auth due to NDFA/LPFA',
  taxElections: 'Client Authorization Needed For Tax Elections',
  schwabReview: 'Schwab review',
  transactionReview: 'Review of Certain Withdrawals is Required'
};

export const recipientType = {
  firstParty: 'firstParty',
  thirdParty: 'thirdParty',
  unselected: ''
};

export const payeeType = {
  firstParty: 'firstParty',
  thirdParty: 'thirdParty',
  unselected: ''
};

export const MediaTypeCode = {
  J: 'J',
  C: 'C',
  W: 'W',
  A: 'A',
  ACH: 'ACH',
  ASC: 'ASC',
  WSC: 'WSC'
};

export const MediaTypeCdDict: { [key in MediaTypeCd]: TransactionType } = {
  J: 'internal-transfer',
  C: 'check',
  W: 'wire',
  A: 'ach',
};

export const viewPageTitles = {
  standingAuth: 'Standing authorization view',
  transaction: 'Transaction view',
  template: 'View template'
};

export const InstructionStatusCdDict: { [key: string]: InstructionStatusCd } = {
  active: 'ACTV',
  inactive: 'INAC',
};

export const enum transactionTypeLabels {
  ach = 'ACH (MoneyLink)',
  internalTransfer = 'Internal transfer (journal)',
  check = 'Check',
  wire = 'Wire',
}

export const tweTransactionTypeDict: { [key: string]: string } = {
  C: 'Check',
  J: 'Internal transfer',
  A: 'Ach',
  W: 'Wire',
};

export const accountDetailsLabel = {
  accountType: 'Account type',
  accountNumber: 'Account number',
  primaryAccountHolder: 'Primary account holder',
  masterAccount: 'Master account',
  taxId: 'From account tax ID/SS#',
  requestingAccountHolder: 'Account holder requesting transaction',
  nickname: 'Nickname'
};

export const fromAccountDetailsLabel = {
  masterAccount: 'Master Account',
  accountNumber: 'Account Number',
  accountType: 'Account Type',
  primaryAccountHolder: 'Primary Account Holder'
};

export const receivingAccountDetailsLabel = {
  financialInstitution: 'Financial Institution',
  accountName: 'Account Name',
  accountNumber: 'Account Number',
  accountType: 'Account Type',
  abaNumber: 'ABA Number'
};

export const receivingAccountDetailsItLabel = {
  financialInstitution: 'Financial Institution',
  accountNumber: 'Account Number',
  availableCash: 'Available Cash',
  registrationDetails: 'Registration Details',
  financialInstitutionValue: 'Charles Schwab Bank SSB'
};

export const payeeDetailsCheckLabel = {
  payeeNames: 'Payee Name(s)',
  memo: 'Memo',
  deliveryAddress: 'Delivery Address'
};

export const recipientDetailsWireLabel = {
  recipientAccountNumber: 'Recipient Account Number',
  recipientAccountIBAN: 'Recipient Account (IBAN)',
  recipientType: 'Recipient Type',
  recipientName: 'Recipient Name (Person/Business)',
  recipientAddress: 'Recipient Address'
};

export const clientAuthDetailsLabel = {
  useEAuth: 'Use eAuthorization',
  accountDetails: 'eAuthorization account details'
};

export const sourceOfLastModification = {
  ClientOnline: 'Client Online',
  SchwabInternal: 'Schwab Internal',
  SchwabAdvisorCenter: 'Schwab Advisor Center',
  Schwabinstitutional: 'Schwabinstitutional.com',
  SchwabAdvisorCenterIT: 'Schwabadvisorcenter.com'
};

export const transactionDetailLabels = {
  frequencyDescription: 'Frequency of recurring transaction',
  secondProcessDate: '2nd process date',
  secondCompletionDate: '2nd Completion date',
  secondWithdrawalDate: '2nd withdrawal date',
  endDate: 'End date',
  transactionType: 'Transaction type',
  useStandingAuth: 'Use standing authorization?',
  frequency: 'Frequency',
  closeAccount: 'Close account?',
  reportsRequested: 'Reports requested',
  receivingAccountNumber: 'Receiving account number',
  processDate: 'Process date',
  trustAmount: 'Net transfer amount',
  trustCashAmount: 'Net cash transfer amount',
  maxTransferAmount: 'Maximum transfer amount',
  amount: 'Amount',
  cash: 'Cash',
  receivingAccount: 'Receiving account',
  accountRegistration: 'Receiving account registration',
  receivingAccountCash: 'Receiving account available cash',
  grossNet: 'Gross/Net',
  federalTax: 'Federal tax',
  federalTaxAmount: 'Federal tax amount',
  stateTax: 'State tax',
  stateTaxAmount: 'State tax amount',
  netCashAmount: 'Net cash amount total',
  distributionReason: 'Distribution reason',
  payIncome: 'Pay income',
  standingAuthDetails: 'Standing authorization details',
  bundledStandingAuthDetails: 'Bundled standing authorization details',
  contributionType: 'Contribution type',
  iraContributionType: 'IRA contribution type',
  trustIncomePercent: 'Income',
  trustPrincipalPercent: 'Principal',
  trustTaxCode: 'Trust tax code',
  trustPaidFor: 'Paid for',
  trustComment: 'Trustee/IA comments',
  isThereAnIntermediaryInstitution: 'Is there an intermediary institution?',
  isThereAnIntermediaryInstitutionHorizontalLabel: 'Is there an intermediary bank?',
  intermediaryInstitutionName: 'Intermediary Institution name',
  account: 'Account',
  intermediaryAccountName: 'Intermediary account name',
  intermediaryAccountNumber: 'Intermediary account number',
  intermediaryAccountNumberHorizontalLabel: 'Intermediary account number',
  intermediaryDetails: 'Intermediary details',
  intermediaryDetailsHorizontalLabel: 'Intermediary address',
  creditToInstitutionName: 'Intermediary Institution name',
  creditToAccountNumber: 'Intermediary account number',
  creditToDetails: 'Intermediary details',
  creditToAccountName: 'Second intermediary account name',
  creditToAccountNumberHorizontalLabel: 'Second intermediary account number',
  creditToDetailsHorizontalLabel: 'Second intermediary address',
  receivingBankAccountNumber: 'Receiving bank account number',
  isoReceivingBankAccountNumber: 'Recipient account number',
  isoReceivingIBAN: 'Recipient account (IBAN)',
  taxPayerId: 'Taxpayer ID',
  taxTypeCode: 'Tax type code',
  taxMonth: 'Tax month',
  taxYear: 'Tax year',
  receivingAccountHolder: 'Receiving account holder',
  recipient: 'Recipient',
  recipientHorizontalLabel: 'Recipient Type',
  wireAmount: 'Wire amount',
  wireAmountUS: 'Wire amount US$',
  netWireAmount: 'Net wire amount',
  grossWireAmount: 'Gross wire amount',
  wireFee: 'Wire fee',
  foreignCurrencyAmount: 'Foreign currency amount',
  currency: 'Currency',
  exchangeRate: 'Exchange rate',
  totalWithdrawalAmount: 'Total withdrawal amount (including wire fee)',
  remittanceInformation: 'Remittance information',
  wireTransmissionNotes: 'Wire transmission notes (optional)',
  wireIrsTransmissionNotes: 'Transmission notes for tax remittance',
  abaNumber: 'ABA number',
  receivingBankAbaNumber: 'Receiving bank ABA number',
  intermediaryBankAbaNumber: 'Intermediary bank ABA number',
  receivingBankDetails: 'Receiving bank details',
  saIsoReceivingBankDetails: 'Recipient bank information',
  intermediaryBankDetails: 'Intermediary bank information',
  intermediaryBankInformation: 'Bank information',
  intermediaryUseSloaBicBankDetails: 'Business ID code (BIC)',
  recipientName: 'Recipient name',
  recipientAddress: 'Recipient address',
  trustTaxCategory: 'Trust tax category',
  depositTaxCode: 'Deposit tax code',
  payee: 'Payee',
  payeeName: 'Payee name',
  deliveryAddress: 'Delivery address',
  deliveryMethod: 'Delivery method',
  checkReason: 'Check reason',
  memo: 'Memo',
  costBasisSelected: 'Cost basis method selected',
  transferType: 'Transfer type',
  positions: 'Positions',
  positionsCash: 'Positions and cash',
  transferDirection: 'Transfer direction',
  sourceOfFunds: 'Source of funds',
  accountToReceiveFunds: 'Account to receive funds',
  nextExpectedWithdrawalDate: 'Next expected withdrawal date',
  expectedWithdrawalDate: 'Expected withdrawal date',
  grossAmount: 'Gross amount',
  completionDate: 'Completion date',
  nextCompletionDate: 'Next completion date',
  fundsAvailableToTrade: 'Funds available to trade',
  contributionReason: 'Contribution reason',
  nextProcessDate: 'Next process date',
  costBasisDefualt: 'Cost basis method default',
  depositAmount: 'Deposit amount',
  fundHoldDates: 'Fund hold dates',
  asOfDate: 'As of date',
  authorizationNickname: 'Authorization nickname',
  positionEmv: 'Positions (est. market value)',
  totalToReceive: 'Total to receive',
  costBasis: 'Cost basis method',
  checkNumber: 'Check number',
  achIncomingIndicator: 'Transferring funds into the Schwab account',
  achOutgoingIndicator: 'Transferring funds out of the Schwab account',
  internalTransferJournal: 'Internal transfer (journal)',
  frequencyOfRecurringTransfer: 'Frequency of recurring transfer',
  totalWithdrawalAmountCheck: 'Total Withdrawal Amount',
  clearingSystemId: 'Clearing system ID',
  bankInformation: 'Bank information',
  transmissionNotes: 'Transmission notes',
  accountNumber: 'Account number',
  iban: 'International account number (IBAN)',
  accountHolderRequestingTransaction: 'Account holder requesting transaction',
  standingAuthorizationsFound: 'standing authorizations found for this account',
  templatesFound: 'templates found for this account'
};

export const registrationTypes = { educationalSavings: 'Educ Savings' };

export const AccountTypes = {
  rothContributory: 'RH',
  rothConversion: 'RV'
};

export enum IraShortNames {
  ROLLOVER_IRA = 'Rollover',
  SIMPLE_IRA = 'Simple Ira',
  CONTRIBUTORY_IRA = 'Contrib',
  ROTH_CONTRIBUTORY_IRA = 'Roth Contrib',
  ROTH_CONVERSION_IRA = 'Roth Conversion',
  CUSTODIAL_IRA = 'Custodial Ira',
  CUSTODIAL_ROTH_CONTRIBUTORY_IRA = 'Cust Roth Cont',
  CUSTODIAL_ROTH_CONVERSION_IRA = 'Cust Roth Conv',
}

export const enum transferTypes {
  POSITIONS = 'positions',
  CASH = 'cash',
  POSITIONS_CASH = 'positionsCash',
}

export const enum shortRegTypes {
  pensionTrust = 'Pen Trust',
  conservatorship = 'Conserv',
  guardianship = 'Guardian'
}

export const enum transactionDirection {
  in = 'Incoming',
  out = 'Outgoing',
}

export const enum toFromAccountAffiliate {
  schwab = 'SCH',
  external = 'EXTERNAL',
}

export const enum dateTypes {
  settlementDate = 'SettlementDate',
  initiationDate = 'InitationDate'
}

export type position = 'top' | 'bottom' | 'left' | 'right';

export type BannerTypes = 'error' | 'warning' | 'information' | 'confirmation';

export type StwProcessCode = 'I' | 'N' | '';

export type HttpMethods = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';

export type PreferenceTypes = 'sort' | 'order';

export enum ServiceErrorCodes {
  CH, // checks-api - 0
  JN, // journals-api - 1
  ML, // moneylinks-api - 2
  TW, // twepopup-api - 3
  IN, // initrelease-api - 4
  DR, // drafts-api - 5
  SV, // statusview-experience-api - 6
  MM, // mm-experience-api - 7
  US, // usesloa-api - 8
  PT, // ptrs-api - 9
  NA, // NA - 10
}

export const DepositTaxCodeMap = [
  'CASH DEPOSIT: 201',
  'MISCELLANEOUS INCOME: 524',
  'NOTE INTEREST: 367',
  'NOTE PRINCIPAL: 049',
  'OTHER TRUST & ESTATES INCOME (K-1): 526',
  'PARTNERSHIP INCOME - DIVIDENDS: 377',
  'PARTNERSHIP INCOME - INTEREST: 378',
  'RENTAL INCOME: 252',
  'RENTAL PROPERTY - OTHER INCOME: 534',
  'TRANSFER FROM PRIOR TRUSTEE: 352'
];

export const fedTaxErrorMap = {
  required: 'Fed tax is required.',
  notAPositiveNumber: 'Fed Tax percentage must be a positive whole number.',
  notAWholeNumber: 'Fed Tax percentage must be a positive whole number.',
  maxlength: 'Please enter no more than 10 digits.',
  oneTimeCheckGreaterThan100: 'Update value so federal tax withholding does not exceed 100%.',
  greaterThanOrEqualTo100: 'Federal tax withholding cannot exceed 99.99%. Update value or request a one-time check to withhold 100%.',
  greaterThan99Fed: 'Federal tax withholding cannot exceed 99.99%.',
  internationalFedTaxError: 'International distributions require a minimum 10% federal tax withholding rate to meet IRS regulations',
  cashieringinternationFedTaxError: 'TRANSACTION REQUIRES MINIMUM 10% FED TAX WITHHOLDING RATE PER IRS REGULATIONS.',
  cashieringInternalTransferInternationalFedTaxError: 'TRANSACTION REQUIRES MINIMUM 10% FED TAX WITHHOLDING RATE PER IRS REGULATIONS'
};

export const stateTaxErrorMap = {
  required: 'State tax is required.',
  notAPositiveNumber: 'State Tax percentage must be a positive number.',
  notAWholeNumber: 'State Tax percentage must be a positive whole number.',
  maxlength: 'Please enter no more than 10 digits.',
  oneTimeCheckGreaterThan99State: '	Update value so state tax withholding does not exceed 99.99%.',
  greaterThan99State: 'State tax withholding cannot exceed 99.99%.',
  belowStateTax: 'Updating tax withholding elections below the required minimums for the States MI or MN cannot be done in this workflow.',
  stateTaxErrorTextMS: 'MS State tax required for Early distributions.',
};

export const distributionReasonErrorMap = {
  required: 'Distribution reason needs to be selected',
  qcdReasonRequired: 'Update to 7-QCD or Cancel to remain as Normal (7)'
};

export let amountErrorMap = {
  required: 'Enter an amount.',
  notAPositiveNumber: 'Amount must be numeric (i.e. 10,000.00).',
  exceeds14Digits: 'Exceeds maximum allowable amount',
  moreThan2DecimalPlaces: 'Amount cannot contain more than 2 decimal places.'
};

export function addMaxAmountError(maxAmount: string): void {
  amountErrorMap = {
    ...amountErrorMap,
    ...{ exceedsMaxTransferAmount: `Transfer amount exceeds maximum allowable amount of ${maxAmount}.` }
  };
}

export const toAccountErrorMap = {
  required: 'Account number is required.',
  minlength: 'Please enter a valid Schwab account number.',
  maxlength: 'Please enter a valid Schwab account number.'
};

export const receivingAccountErrorMap = {
  required: 'Account to receive funds is required.',
  minlength: 'Please enter a valid Schwab account number.',
  maxlength: 'Please enter a valid Schwab account number.'
};

export const authNicknameErrorMap = { pattern: 'Nicknames cannot include special characters except #, $, %, &, \' and *. Please enter a new nickname.' };

export const templateNicknameErrorMap = {
  pattern: 'Nicknames cannot include special characters except #, $, %, &, \' and *. Please enter a new nickname.',
  required: 'Invalid nickname.'
};


export let abaErrorMap = {
  required: 'Receiving bank ABA number is required.',
  minlength: 'Please enter a nine-digit ABA number.',
  maxlength: 'Please enter a nine-digit ABA number.',
  pattern: 'Characters allowed are 0-9'
};

export let IntermediaryAbaErrorMap = {
  required: 'Intermediary bank ABA number is required.',
  minlength: 'Please enter a nine-digit ABA number.',
  maxlength: 'Please enter a nine-digit ABA number.',
  pattern: 'Characters allowed are 0-9',
  isIrsAbaAndIntermediaryError: 'Remove the intermediary bank for tax payments'
};

export const taxPayerIdErrorMap = {
  required: 'Enter taxpayer ID ',
  minlength: 'Must be a 9-digit number',
  maxLength: 'Must be a 9-digit number',
  pattern: 'Characters allowed are 0-9'
};

export const taxTypeCodeErrorMap = {
  required: 'Enter tax type code ',
  minlength: 'Use a valid tax type code ',
  maxLength: 'Use a valid tax type code ',
  pattern: 'Characters allowed are capital A-Z and 0-9',
};

export const taxPayerNameErrorMap = (maxlength: number) => {
  return {
    required: 'Enter taxpayer name',
    pattern: 'Characters allowed are A-Z, 0-9 and \/-?:()\.,\'+ !#$%&*=^_`\\{|}~";<>@[]+',
    maxlength: `Please stay within ${maxlength} characters.`,
    firstCharAlphaNumeric: 'First character must be A-Z, 0-9.'
  };
};

export function addDetailsApiError(errorText: string, isFromIntermediaryInterim: boolean): void {
  if (isFromIntermediaryInterim) {
    IntermediaryAbaErrorMap = {
      ...IntermediaryAbaErrorMap,
      ...{ detailsApiError: `${errorText}` }
    };
  } else {
    abaErrorMap = {
      ...abaErrorMap,
      ...{ detailsApiError: `${errorText}` }
    };
  }
}

export const checkMemoErrorMap = { maxlength: 'Please stay within the character limits.', };

export const transmissionNotesErrorMap = {
  pattern: 'Characters allowed are A-Z, 0-9 and +/.-()\',?:',
  maxlength: 'Please stay within the character limits.',
  firstCharAlphaNumeric: 'First character must be A-Z, 0-9.'
};

export const transmissionNotesErrorMapIso = {
  pattern: 'Characters allowed are A-Z, 0-9 and +/.-()\',?:',
  maxlength: 'Please stay within the character limits.',
};

export const receivingAccountHolderErrorMap = (displayName: string, maxlength: number) => {
  return {
    required: `${displayName} is required.`,
    pattern: 'Characters allowed are A-Z, 0-9 and +/.-()\',?:',
    maxlength: `Please stay within ${maxlength} characters.`,
    firstCharAlphaNumeric: 'First character must be A-Z, 0-9.'
  };
};

export const intermediaryErrorMap = (displayName: string, maxlength: number) => {
  return {
    required: `${displayName} is required.`,
    pattern: 'Characters allowed are A-Z, 0-9 and +/.-()\',?:',
    maxlength: `Please stay within ${maxlength} characters.`,
    firstCharAlphaNumeric: 'First character must be A-Z, 0-9.',
    invalidPhoneFormat: 'Phone number must be formatted as xxx-xxx-xxxx or xxx-xxx-xxxx Ext. xxxx',
  };
};


export const thirdPartyCheckFieldsErrorMap = (displayName: string) => {
  return {
    required: `${displayName} is required.`,
    pattern: 'ZIP code must be numeric and can be entered as either \'12345\' or \'12345-1234\'',
  };
};
export const datePickerErrorMap = {
  required: 'is required.',
  dateInThePast: 'cannot be in the past. Please revise.',
  futureRMDYear: 'must be in the next calendar year.',
  datePastMax: 'cannot be past the maximum allowed date. Please revise.',
  weekend: 'cannot be a weekend. Please revise.',
  pattern: 'is not valid.',
  dateLessThanMin: 'Earliest possible completion date is'
};

export const trustIncomePrincipalErrorMap = {
  required: 'is required.',
  greaterThan100: 'cannot exceed 100%',
  notAPositiveNumber: 'must be a positive number.',
  sourceDoNotSumTo100: 'The Total sum of Income and Principal Percentage must be equal to 100.',
  receivingDoNotSumTo100: 'The Total sum of Income and Principal Percentage must be equal to 100.'
};

export type overdraftRulesPopupErrorTypes = 'overridePopupIncomeError' | 'overridePopupPrincipalError' | 'overridePopupIncomeAndPrincipalError';
export type overdraftRulesErrorTypes = 'insufficientFundError' | 'incomePercentError' | 'principalPercentError' | 'incomeAndPrincipalPercentError' | 'toIncomePercentError' | 'toPrincipalPercentError' | 'toIncomeAndPrincipalError';

export const overdraftRulesPopupErrors: Record<overdraftRulesPopupErrorTypes, string> = {
  overridePopupIncomeError: 'Transaction violates the account overdraft rules for income. Do you wish to override?',
  overridePopupPrincipalError: 'Transaction violates the account overdraft rules for principal. Do you wish to override?',
  overridePopupIncomeAndPrincipalError: 'Transaction violates the account overdraft rules for income and principal. Do you wish to override?'
};

export const overdraftRulesError: Record<overdraftRulesErrorTypes, string> = {
  insufficientFundError: 'Insufficient funds on this account.',
  toIncomePercentError: 'Transaction violates the account overdraft rules for income.',
  toPrincipalPercentError: 'Transaction violates the account overdraft rules for principal.',
  toIncomeAndPrincipalError: 'Transaction violates the account overdraft rules for income and principal.',
  incomePercentError: 'Transaction violates the account overdraft rules for income.',
  principalPercentError: 'Transaction violates the account overdraft rules for principal.',
  incomeAndPrincipalPercentError: 'Transaction violates the account overdraft rules for income and principal.',
};

export const moneyMovementAcknowledgeError: WarningOrError = {
  messageLevel: 1,
  messageId: 'money-movement-acknowledgement',
  messageText: 'Review',
  messageField: 'Money movement acknowledgement'
};

export const amountTypeDict: { [key: string]: AmountType } = {
  gross: 'gross',
  net: 'net',
};

export type PayIncomeType = 'Dividend' | 'Interest' | 'All' | 'Money Market';

export const payIncomeDict: { [key: string]: PayIncomeType } = {
  I: 'Interest',
  D: 'Dividend',
  A: 'All',
  M: 'Money Market'
};

export const enum ApiEndpointType {
  moneylinkInput = 'MoneylinkInput',
  moneylinkVerify = 'MoneylinkVerify',
  moneylinkAcknowledge = 'MoneylinkAcknowledge',
  moneylinkInquiry = 'MoneylinkInquiry',
  internalTransferInput = 'InternalTransferInput',
  internalTransferVerify = 'InternalTransferVerify',
  internalTransferListVerify = 'InternalTransferListVerify',
  internalTransferAcknowledge = 'InternalTransferAcknowledge',
  internalTransferInquiry = 'InternalTransferInquiry',
  wireInputV3 = 'WireInputV3',
  wireDetails = 'WireDetails',
  wireVerifyV3 = 'WireVerifyV3',
  wireInquiry = 'WireInquiry',
  wireAcknowledgeV3 = 'WireAcknowledgeV3',
  withdrawalDate = 'WithdrawalDate',
  standingAuthorizations = 'StandingAuthorizations',
  overview = 'StatusviewOverview',
  checkInput = 'CheckInput',
  checkVerify = 'CheckVerify',
  checkAcknowledge = 'CheckAcknowledge',
  checkInquiry = 'CheckInquiry',
  transInquiry = 'TransInquiry',
  wireTemplate = 'WireTemplate',
  verifyTaxWithholdings = 'verifyTaxWithholdings',
  submitTaxWithholdings = 'submitTaxWithholdings',
  initReleaseByDraftId = 'initReleaseByDraftId'
}

export const pdfLabelsToDetails = {
  beneficiaryAccountNumber: 'Account #:',
  finalRecipientAccountNumber: 'Final Recipient Account #:',
  recipientAccountNumberOneStep: 'Recipient Account #:',
  beneficiaryNameLabel: 'Beneficiary Name:',
  finalRecipientNameLabel: 'Final Recipient Name:',
  recipientNameOneStepLabel: 'Recipient Name:',
  beneficiaryAddress: 'Beneficiary Address:',
  finalRecipientAddress: 'Final Recipient Address:',
  recipientAddressOneStep: 'Recipient Address:',
  beneficiaryCountry: 'Beneficiary Country:',
  finalRecipientCountry: 'Final Recipient Country:',
  recipientCountryOneStep: 'Recipient Country:',
  receivingBankAbaNumber: 'Rec Bank ABA #:',
  receivingBankAbaNumberOneStep: 'Receiving Bank ABA #:',
  intermediaryBankAbaNumber: 'Intermediary Bank ABA #:',
  receivingBankBankId: 'Bank ID:',
  receivingBankName: 'Rec Bank Name:',
  receivingBankNameOneStep: 'Receiving Bank Name:',
  intermediaryBankName: 'Intermediary Bank Name:',
  receivingBankAddress: 'Rec Bank Address:',
  receivingBankAddressOneStep: 'Receiving Bank Address:',
  intermediaryBankAddress: 'Intermediary Bank Address:',
  receivingBankCountry: 'Rec Bank Country:',
  receivingBankCountryOneStep: 'Receiving Bank Country:',
  intermediaryBankCountry: 'Intermediary Bank Country:',
  receivingBankPhone: 'Rec Bank Phone:',
  intermediaryAba: 'Intermediary Bank ID:',
  intermediaryBankIdType: 'Intermediary Bank ID Type:',
  intermediaryName: 'Intermediary Name \n(Registration):',
  creditToWireName: 'Second Intermediary Name \n(Registration):',
  intermediaryAccountNumber: 'Intermediary Account #:',
  creditToAccountNumber: 'Second Intermediary Account #:',
  intermediaryAddress: 'Intermediary Address:',
  creditToIntermediaryAddress: 'Second Intermediary Address:',
  creditToIntermediaryCountry: 'Second Intermediary Country:',
  creditToIntermediaryPhone: 'Second Intermediary Phone:',
  intermediaryCountry: 'Intermediary Country:',
  intermediaryPhone: 'Intermediary Phone:',
  creditToAccount: 'Credit to Account #:',
  creditToName: 'Credit To Name:',
  creditToAddress: 'Credit to Address:',
  creditToCountry: 'Credit to Country:',
  creditToPhone: 'Credit to Phone',
  toAccount: 'To Account:',
  toAccountRegistration: 'To Account Registration:',
  payee: 'Payee',
  checkReason: 'Check reason',
  memo: 'Memo',
  recipientAddress: 'Recipient Bank Address:',
  recipientName: 'Recipient name',
  recipientBankAccountNumber: 'Recipient Bank Account #',
  recipientBankName: 'Recipient Bank Name:',
  recipientBankCountry: 'Recipient Bank Country'
};

export const pdfLabelsSubmitDetails = {
  processDate: 'Process Date:',
  checkProcessDate: '**Process Date:',
  additionalWireInstructions: 'Additional Wire\n Instructions:\n(Including Client Escrow Info)',
  nextProcessDate: 'Next Process Date:',
  requestedDate: 'Requested Date:',
  lastModifiedDate: 'Last Modification Requested Date:',
  wireAmount: 'Wire Amount:',
  withdrawalAmount: 'Withdrawal Amount:',
  educationalDistReason: 'EDUCATION (M)',
  qualifiedDistReason: 'QUALIFIED (Q)',
  fedTax: 'Fed Tax:',
  stateTax: 'State Tax:',
  distributionReason: 'Distribution Reason:',
  wireFee: 'Wire Fee:',
  transactionType: 'Type:',
  journalAmount: 'Journal Amount:',
  internalTransferAmount: 'Internal Transfer Amount:',
  totalWithdrawalAmount: 'Total Withdrawal Amount',
  totalToReceiveAmount: 'Total to Receive',
  withholdFederalTax: 'Withhold Federal Taxes:',
  fedTaxAmount: 'Fed Tax:',
  withholdStateTax: 'Withhold State Taxes:',
  stateTaxAmount: 'State Tax:',
  netAmount: 'Net Amount:',
  contributionReason: 'IRA Contribution Type:',
  accountNumber: 'To Account:',
  accountRegistration: 'To Account Registration:',
  secondProcessDate: '2nd Process Date:',
  secondCompletionDate: '2nd Completion Date:',
  endDate: 'End Date:',
  payIncome: 'Pay Income:',
  frequencyDescription: 'Frequency:',
  iraContributionType: 'IRA contribution type',
  checkAmount: 'Check Amount:',
  withdrawalReason: 'Withdrawal Reason:',
  checkDeliveryMethod: 'Check Delivery Method:',
  overnightDeliveryMethodValue: 'Overnight (Next Business Day) - Charge Client',
  standardDeliveryMethodValue: 'Standard Mail',
  checkFee: 'Check Fee:',
  closeAccount: 'Close Account:',
  totalDistributionIncludingResiduals: 'Total distribution including residuals',
  taxId: 'Taxpayer ID',
  taxTypeCode: 'Tax Type Code',
  taxYear: 'Tax Year',
  taxMonth: 'Tax Month',
  transmissionNotesIrs: 'Transmission Notes for Tax Remittance'
};

export enum WireAbaCodes {
  ABA_OK = '1',
  ABA_ERROR = '2',
  ABA_WITH_WARNING = '3',
  ABA_WITH_WARNING_TWO_INSTITUTIONS = '4'
}

export const sacContextTypeMap = {
  ACCOUNT: 0,
  MASTER: 1,
  GROUP: 2,
  CUSTOMER: 3,
  HOUSEHOLD: 4,
  FIRM: 5,
  BANKACCOUNT: 6,
  PENDINGACCOUNT: 7,
  PALACCOUNT: 8,
  UNKNOWN: 9
};

export const transactionCodes = {
  internalTransferFromPtrs: 'JNLDSB',
  internalTransferToPtrs: 'CASHDEP',
  checkTransactionCode: 'CHECKDSB'
};

export const enum transactionStatuses { inProcess = 'In process', }

export const transactionStatusDict: { [key: string]: string } = { PEND: 'In process' };

export const createRuleInRConstants = {
  modalDisclaimerText: 'Transactions and standing authorization matching any rules will need to be reviewed prior to processing.',
  deleteModalDisclaimerText: 'This will only impact new transactions. All pending transactions will still need to be reviewed and released before processing.',
  callToCustomRuleDeleteFailedText: 'Error - unable to delete rule',
  callToCustomRulePostFailedText: 'Unable to save rule ',
  deleteModalSuccessToastrMessage: 'Rule Deleted'
};

export const positionConstants = {
  tableRowHeight: 29,
  tableMinimumErrorRowHeight: 105,
  tableWholeNumberErrorRowHeight: 70,
  tableDenominationErrorRowHeight: 80,
  tableRestrictedMessageRowHeight: 48,
  tableLotFractionalRowHeight: 80,
  tablePositionFractionalRowHeight: 105,
  tableSelectAllCheckboxColumnWidth: 35,
  costBasisMap: new Map<string, string>(
    [
      ['BTAX', 'Tax Lot Optimizer'],
      ['FIFO', 'FIFO (first-in, first-out)'],
      ['LIFO', 'LIFO (last-in, first-out)'],
      ['HCLOT', 'Highest-cost lot'],
      ['LCLOT', 'Lowest-cost lot'],
      ['None', 'Select lots manually'],
      ['VSP', 'Select lots manually']
    ]
  ),
  SetToAverageInformationMessage: 'To meet IRS requirements, we must transfer any positions set to Average using the FIFO cost basis method. We\'ll apply your selected cost basis method to any other positions included in this transaction.',
  SelectPositionErrormessage: 'Select at least one position to transfer.',
  SelectPositionErrorMessagePhase2: 'Select at least one position to transfer for each receiving account.',
  SelectToAccountsPositionErrormessagePhase2: 'Select at least one position to transfer for the following receiving account(s):',
  PositionProcessDateToolTipMessage: 'Any transaction that includes positions must be dated same-day. Every effort is made to process internal transfers received by 2:00 p.m. ET on the same business day. Actual processing time may vary based on receipt of authorization. Process dates default to the next business day if entered after the 2:00 p.m. ET cutoff.',
  AccountHasNoPositionsMessage: 'This account has no positions to transact. You can transact with cash if funds are available.',
  PositionLotErrorResponseMessage: 'We\'re unable to retrieve position details at this time. Please try again later.',
  ToAccountNotEnteredMessage: 'An account number must be entered before positions can be displayed.',
  PositionsViewPageBannerMessage: 'Estimated market value is calculated when the transaction is submitted. Changes in market conditions and available securities during processing may result in a different final market value.',
  PositionsViewPageBannerMessageText: 'Estimated market values shown are calculated at this moment in time and are subject to market changes and availability of securities while processing.',
  TaxesApplicableViewPageBannerMessageText: 'If the taxes are withheld, the Federal tax, State tax and Cash withdrawal amounts will also be updated when the request is completed. Federal and State taxes are calculated using gross cash and position values. You can view the information on your monthly statement.',
  maxLotsAllowed: 250,
  notValidShortPositionErrorMessage: 'Short Position-Unable to journal-Contact your service team.',
  shortPositionErrorMessage: 'Short position-unable to transfer. Contact your service team.',
  notValidReorganizationPositionErrorMessage: 'Position undergoing Reorganization-unable to journal.',
  wholeNumberManualError: 'Enter a whole number - quantity of all cost basis lots including any fractional shares must equal quantity being transferred.',
  reorganizationPositionErrorMessage: 'Position undergoing reorganization. Unable to transfer.',
  maxLotsWarning: 'Some position(s) exceed the maximum of 250 lots for this transaction. Reduce the number of lots to continue.',
  maxLotsWarningPhase2: 'The following position transfers have exceeded the maximum limit of 250 lots per position to each receiving account. Reduce the number of lots to continue.',
  positionMismatchRestriction: 'Due to a pending trade or pending lot transfer, position and lot level shares do not match. Unable to transfer.',
  positionMismatchDisclaimer: 'Due to pending trades or transactions, some positions in your account will show a different number of shares from the total number of shares at the lot level.',
  positionQuantityExceedsAvailableShares: 'Quantity exceeds available shares',
  lotExceedsSixDecimalsWarningMessage: 'Enter a value with no more than 6 decimals',
  positionFractionalQuantityMismatch: 'Fractional quantity entered must equal fractional positions held',
  positionWholeNumberError: 'Enter a whole number',
  taxLotOptimizerInputWarningMessage: 'With "Tax Lot Optimizer" designated as the default, the transfer will be excecuted with the "Highest-Cost Lot" cost basis method. "Tax Lot Optimizer" only applies to security sales.',
  taxLotOptimizerWarningMessage: 'With "Tax Lot Optimizer" selected, the transfer will be executed with the "Highest-cost lot" cost basis method. "Tax Lot Optimizer" only applies to security sales.',
  confirmationErrorBanner: 'There are 1 or more transactions with errors that could not be submitted. Please select the receiving account(s) below to get more information.',
  duplicateRestrictionDisclaimer: 'This account has positions with restricted lots that cannot be transferred. If you select lots manually, restricted positions will show an explanation message on the same row. Only unrestricted shares that can be moved are displayed in this table.',
  duplicateRestrictionDisclaimerMF30DaySpecific: 'Restricted lots pending the 30-day hold are not on display. Only unrestricted shares that can be moved are shown.'
};

export const totalDistributionConstants = {
  totalDistributionWarningText: 'Internal Transfer requests designated as total distributions are not eligible for eAuthorization. We\'ll generate a prefilled authorization form for your client to sign once you submit this request.',
  totalDistributionWarningTextChecks: 'Check requests designated as total distributions are not eligible for eAuthorization. We\'ll generate a prefilled authorization form for your client to sign once you submit this request.'
};

export const enum achRecTypeCodes {
  onRequest = 'ASC',
  recurring = 'ARC',
  moneylink = 'AEC'
}

export type CheckDeliveryCodes = 'M' | 'O';
export type CheckDeliveryMethods = 'standard' | 'overnight';

export const CheckDeliveryCodesType: { [key in CheckDeliveryCodes]: string } = {
  M: 'standard',
  O: 'overnight'
};

export const checkDeliveryCodesDict: { [key in CheckDeliveryMethods]: CheckDeliveryCodes } = {
  standard: 'M',
  overnight: 'O'
};

export const pageInContext: { [key: string]: PageNameTypes } = {
  view: 'view',
  review: 'review',
  confirmation: 'confirmation',
  input: 'input',
  viewMsv: 'view-msv'
};

export const createTypes: { [key: string]: CreateTypes } = {
  transaction: 'transaction',
  standingAuthorization: 'standing-authorization',
  initiateAndRelase: 'initiate-release',
  empty: ''
};

export type PageNameTypes = 'view' | 'review' | 'confirmation' | 'input' | 'view-msv';

export type CreateTypes = 'transaction' | 'standing-authorization' | 'initiate-release' | 'master-account-view' | '';

export type tableName = 'standing authorizations' | 'standing' | 'transactions' | 'init' | 'recurring' | 'master transactions' | 'init master transactions view' | 'master standing authorizations' | 'create rule';

export type transactionstableTabName = 'All' | 'Upcoming' | 'Recent' | 'Recurring' | 'Saved wire templates';

export type standingAuthTableTabName = 'ACH transfers' | 'All' | 'Internal transfers' | 'Wires' | 'Checks';

export type masterTransactionsTableTabName = 'Transaction Status' | 'Recurring' | 'Activity Report';

export type masterStandingAuthTableTabName = 'ALL';

export type SortOptions = 'asc' | 'desc' | null;

export const transactionTableTabs: { [key: string]: transactionstableTabName } = {
  all: 'All',
  upcoming: 'Upcoming',
  recent: 'Recent',
  recurring: 'Recurring',
  templates: 'Saved wire templates'
};

export const standingAuthTableTabs: { [key: string]: standingAuthTableTabName } = {
  ach: 'ACH transfers',
  all: 'All',
  internalTransfers: 'Internal transfers',
  wires: 'Wires',
  checks: 'Checks'
};

export const MsvTransactionTypeRemaps = {
  internalTransfer: 'Internal Transfer',
  ach: 'ACH'
};

export const masterTransactionsTableTabs: { [key: string]: masterTransactionsTableTabName } = {
  transactionStatus: 'Transaction Status',
  recurring: 'Recurring',
  activityReport: 'Activity Report',
};

export const MasterStandingAuthTableTabs: { [key: string]: masterStandingAuthTableTabName } = { all: 'ALL' };

export const enum bankIdentifierTypes {
  aba = 'USABA',
  iban = 'IBAN',
  accountNumber = 'Account',
  bic = 'BIC',
}

export const clearingSystemIdTypes = [
  'AUBSB',
  'CACPA',
  'CACPA',
  'DEBLZ',
  'GBDSC',
  'HKNCC',
  'INFSC',
  'NZNCC',
  'SGIBG'
];

export const enum navRouteConstants {
  moneyMovement = 'money-movement',
  createTransaction = 'money-movement/create-transaction',
  standingAuth = 'money-movement/standing-authorizations',
  depositCheck = 'money-movement/deposit-check',
  setupEAuth = 'money-movement/setup-eAuthorization',
  initiateAndRelease = 'money-movement/initiate-and-release',
  advancedfeatures = 'money-movement/advancedfeatures',
}

export const NewwireRegTypes = ['CONSERV', 'ESTATE', 'GUARDIAN', 'TEST TRUST'];

export const NewRegTypes = ['TEST TRUST']; // TODO: Add additional reg types in here as we get to them

export const taxElections = {
  federal: 'No Federal Election',
  state: 'No State Election'
};

export const accessFunctions = {
  accessInitiateMoneyMovement: 'Access Initiate Money Movement',
  accessReleaseMoneyMovement: 'Access Release Money Movement',
  updateMoveMoney: 'Update Move Money',
  viewMoveMoney: 'View Move Money',
  updateMoneyLink: 'Update MoneyLink',
  requestWire: 'Request Wire',
  journalPositionLotSelection: 'Access MM ExperienceApi Routing Journals',
  editAchPhase2: 'Access Edit ACH Ph2',
  accessDigitalToPdfTransactions: 'Access PDF Testamentary Accounts',
  accessPositionLotsPhase2: 'Access Optimized UseSLOA Wire Client',
  moveMoneyShellFirms: 'Access Move Money Shell',
  msvStandingAuthFirms: 'Access MSV Standing Auth Table',
  ptrsViewFacility: 'Personal Trust View Facility',
  accessPalWires: 'Access Move Money PAL Wires',
  accessAchPath: 'Access ACH PATH',
};
export const sloaAuthorization = {
  check: 'checkSloa',
  journals: 'journalSloa',
  wire: 'wireSloa'
};

export const ViewType = {
  transaction: 'transaction',
  standingAuth: 'standing-auth'
};

export const RequestTransactionType = {
  JournalSloa: 'JournalSloa',
  JournalOneTime: 'JournalOneTime',
  JournalRecurring: 'JournalRecurring'
};

export const eAuthTooltipText = {
  pendingSetupVerbiage: 'eAuthorization setup is pending for:',
  missingEmailVerbiage: 'You have one or more clients eligible for eAuthorization with no emails set up.',
  addAccountHolderLink: 'Set up an account holder',
  addEditEmailLink: 'Add or edit an email',
  accountHoldersEligible: 'This account has the following approvers available to use eAuthorization:',
  noneAccountHoldersEligible: 'This account is eligible for eAuthorization but no account holders have been set up.',
  accountIneligible: 'This account is not eligible for eAuthorization. Not all account types are eligible.'
};

export const StandingAuthDeleteMessaging = {
  deleteTitle: 'Delete this standing authorization?',
  deleteMessage: 'Are you sure you want to delete this standing authorization? Deletions cannot be undone.',
  deleteButtonText: 'Yes, delete',
  deactivateTitle: 'Deactivate this standing authorization?',
  deactivateMessage: 'Are you sure you want to deactivate this standing authorization? If you do, you can still reactivate it later for future transactions.',
  deactivateButtonText: 'Yes, deactivate'
};

export const sloaAuthorizationsAccessList = [sloaAuthorization.check, sloaAuthorization.journals, sloaAuthorization.wire];

export const disableFieldsWhenEditFlow: { [key in TransactionType]: string[] } = {
  'internal-transfer': ['transactionType', 'extraPrompts.useStandingAuth', 'extraPrompts.useBundledStandingAuth', 'extraPrompts.frequency', 'extraPrompts.transferType', 'transactionDetails.toAccount'],
  ach: [],
  check: ['transactionType', 'extraPrompts.useStandingAuth', 'extraPrompts.frequency', 'extraPrompts.useBundledStandingAuth'],
  wire: [],
  WireSloa: []
};

export const controlsUpdatedOnBlur: string[] = ['modifiedPayeeName1', 'modifiedPayeeName2'];

export const firstTimeUserAgreementText
  = `<b>Introduction</b><br>
  <br>Welcome to Schwab Advisor Services\' Online Cashiering system. The Schwab Advisor Services\' Cashiering system ("Cashiering System") was designed to help investment advisor firms ("IA Firms") and their authorized representatives  ("Users") conduct business with Charles Schwab & Co., Inc.("Schwab") more effectively and efficiently.  The Cashiering System is an electronic channel provided to assist Users with requesting and monitoring disbursements on behalf of clients. The Cashiering System is available only to Users (referred to as "you") who agree to the terms and conditions in this Agreement.
  <br><br>Please take your time to review this important information to ensure that you understand the terms and conditions governing your use of the Cashiering System and its special characteristics. If you have questions about the Cashiering System or the following information, please contact a Schwab Advisor Services representative.
  <br><br>If you agree with the terms and conditions of this Agreement, you should agree below to acknowledge your consent and intention to be bound by these terms and conditions. By agreeing," (i) you represent and warrant that you have the authority to enter into this Agreement and to create binding contractual obligations on behalf of your IA firm, (ii) you indicate that you understand and intend this Agreement to be the legal equivalent of a signed, written contract, and equally binding, and (iii) you represent and warrant that you will use the Cashiering System in a manner consistent with applicable laws and regulations and in accordance with the terms and conditions in this Agreement, as these may be amended by Schwab, on-line or otherwise, from time to time.
  <br><br>This Agreement will be available for your review under the "Agreements" link that appears on one or more pages in SchwabAdvisorCenter.com
  <br><br><b>Schwab Advisor Center Web-Site User Agreement.</b><br>
  <br>Use of the Cashiering System is subject to the Schwab Advisor Center Web Site User Agreement, the Investment Manager Service Agreement, Separate Account Manager Service Agreement, and/or any other applicable agreements, as amended from time to time (collectively, "Schwab Agreements").
  <br><br><b>Cashiering System Authorization</b><br>
  <br>The Cashiering System allows authorized Users to electronically view and initiate fund disbursements from client accounts on their behalf.
  <br><br>Users are automatically enrolled in the view only feature of the Cashiering System.  You may contact your IA Firm\'s administrator to disable this feature.
  <br><br>Only Users who are duly authorized by their IA Firm to request disbursements on behalf of its clients are permitted to utilize the withdrawal feature of the Cashiering System.   Your IA Firm\'s administrator can assist with activating this capability.
  <br><br>By agreeing to the terms and conditions, you acknowledge that you are expressly authorized by your IA Firm to request disbursements on behalf of its clients.  Schwab will have no responsibility to verify this authority.  It is the sole responsibility of your IA Firm to limit online withdrawal access ONLY to authorized Users.
  <br><br><b>Account Enrollment</b><br>
  <br>Users may request online withdrawals for clients that have granted their IA Firm disbursement authorization on their account.  The type and extent of disbursements permitted using the Cashiering System may be limited by the extent of client authorization provided and/or various limitations imposed by Schwab in accordance with our policies and procedures, as these may be amended from time to time.
  <br><br>Only Users who are duly authorized by their IA Firm to request disbursements on its behalf are permitted to utilize the Cashiering System, and you agree that you will keep your User password private and secure.
  <br><br><b>Cutoff & Processing Time</b><br>
  <br>Disbursement instructions submitted via the Cashiering System are subject to the Schwab\'s cut-off and processing times as non-electronic withdrawal requests and may encounter additional delays if approval verification is required.  Please consult the Service Guide for the respective details.  Schwab reserves the right to delay or suspend electronic disbursement requests and to request such supplemental information as it deems reasonably necessary at its discretion.  Schwab\'s liability shall be limited to the extent set forth in the applicable Schwab Agreements.
  <br><br><p ><span>&copy; 2017 Charles Schwab &amp; Co., Inc. All rights reserved. Member</span>
  <a href="http://www.sipc.org/" title="http://www.sipc.org/">
  <span>SIPC</span></a>
  <span>.</span>
  <span> (0305-00444)</span></p>`;

export const cashieringIraAgreementText
  = `<p><b>Tax Withholding Election</b></p>
  <p>This section is not applicable to withdrawals from an Education Savings Account.</p>
  <p>Distributions treated as nonperiodic payments from your IRA (excluding those from Roth IRAs) are generally subject to federal and possibly state income taxes. Even if you elect in writing not to have federal and/or state income tax withheld, when permitted, you are liable for payment of federal and state income taxes on the taxable portion of your distribution. To elect no Federal income tax withheld from your distribution, contact your financial advisor to select a rate of 0%. If you elect to have no tax withheld from your distribution, or if not enough tax is withheld, you may be responsible for payment of estimated taxes. You may also incur penalties under the estimated tax rules if your withholding and estimated tax payments are not sufficient. For more information, see IRS Publication 590-B or consult a tax advisor.</p>
  <p>Your tax withholding election will remain in effect on all distributions from this IRA until you change or revoke it. You may change or revoke your tax withholding election at any time by submitting your request to Schwab. The Federal or combined Federal and State withholding tax rate of 100% will not be retained for future distributions. To process a distribution with a Federal or combined Federal and State withholding tax rate of 100%, please request a one-time check.</p>
  <p>If you are a non-resident alien, a 30% tax withholding rate will apply unless you reside in a country with a lower tax treaty rate and submit a valid IRS Form W-8BEN. Contact us to find out if a lower tax treaty rate applies.</p>
  <p><b>Federal Income Tax Withholding</b></p>
  <p>Your withholding rate is determined by the type of payment you will receive. For nonperiodic payments (see IRS Form W-4R), the default withholding rate is 10%. You can choose to have a different rate by contacting your financial advisor to select a rate between 0% and 100%. Generally, you can’t choose less than 10% for payments to be delivered outside the United States and its possessions. See the attached IRS Form W-4R instructions for more information.</p>
  <p><b>Please note: The attached IRS Form W-4R is for information only. You are not required to complete or return to Schwab the IRS Form W-4R.</b></p>
  <p>Contact your financial advisor if you would like a rate of withholding that is different from the default withholding rate or the withholding rate displayed above. The rate must be a whole number (no decimals). See the attached IRS Form W-4R instructions and current Marginal Rate Tables for additional information. You may use these tables to help you select the appropriate withholding rate for this payment or distribution. Instructions on how to use the tables are included starting with "Suggestion for determining withholding".</p>
  <p><b>State Income Tax Withholding</b></p>
  <p>State tax withholding may be required from your distribution. In some cases, you may elect not to have withholding apply, or you may elect to increase the rate of withholding. In other cases, state tax withholding is not available. Refer to the State Income Tax Withholding Information   sheet for specific information concerning your state. If you do not make an election, Schwab will apply withholding (if required) at the minimum rate based on your state of residency as determined by your legal address of record on your account.</p>
  <p>While Schwab makes every effort to obtain information about state tax laws from sources believed to be reliable, Schwab cannot guarantee the accuracy or timeliness of state tax withholding information because state tax laws are subject to constant change and interpretation. We recommend that you contact your tax advisor regarding your tax withholding elections and to answer any questions that you may have regarding your state's withholding laws.</p>
  <p>If you move between states with differing income tax withholding laws, Schwab will apply state income tax withholding (if required) at the rate you have provided above or at the minimum rate based on the laws for your new state of residency, whichever is higher.</p>
  <p>Residents of Michigan (MI), Minnesota (MN), and Iowa (IA) are required to make their election in the section specific to their state and review the state Declaration where applicable.</p>
  <p><b>Michigan (MI-W4P)</b></p>
  <p>State income tax withholding may be required from your distribution. In some cases, withholding may not apply, or it may be applied at a rate higher than the state’s minimum. In other cases, state income tax withholding may not be available. Refer to the State Income Tax Withholding Information sheet and Form MI W-4P and Instructions for details.</p>
  <p>While Schwab makes every effort to obtain reliable information about state tax laws, Schwab cannot guarantee the accuracy or timeliness of state tax withholding information. We recommend that you contact your tax advisor regarding your tax withholding election and to answer any questions you may have.</p>
  <p>One of the following state income tax withholding elections has been made on your behalf by your financial advisor. You may approve the election or contact your financial advisor to change your state income tax withholding election:</p>
  <ul>
  <li>No state income tax withholding, because my distribution payments are not taxable. Note: Opting out may result in a balance due on your MI-1040, which may be subject to additional penalty and/or interest.</li>
  <li>State income tax withholding applied at a rate that meets or exceeds Michigan’s minimum tax rate.</li>
  </ul>
  <p>If no election had been made and no prior election request was on file, Schwab would apply withholding (if required) at the minimum rate based on the laws for your state of residency, as determined by your legal address of record on your account.</p>
  <p><b>Minnesota (MN-W4P)</b></p>
  <p>State income tax withholding may be required from your distribution. In some cases, withholding may not apply, or it may be applied at a rate higher than the state’s minimum. In other cases, state income tax withholding may not be available. Refer to the State Income Tax Withholding Information sheet and Form W-4MNP and Instructions for details.</p>
  <p>While Schwab makes every effort to obtain reliable information about state tax laws, Schwab cannot guarantee the accuracy or timeliness of state tax withholding information. We recommend that you contact your tax advisor regarding your tax withholding election and to answer any questions you may have.</p>
  <p>One of the state income tax withholding elections has been made on your behalf by your financial advisor. You may approve the election or contact your financial advisor to change your state income tax withholding election.</p>
  <ul>
  <li>No state income tax withholding</li>
  <li>State income tax withholding applied at a rate that meets or exceeds Minnesota’s minimum tax rate</li>
  </ul>
  <p>Declaration: I certify that all information provided is correct.</p>
  <p>If no election had been made and no prior election request was on file, Schwab would apply withholding (if required) at the minimum rate based on the laws for your state of residency, as determined by your legal address of record on your account.</p>
  <p><b>Iowa (IA-W4P)</b></p>
  <p>State income tax withholding may be required from your distribution. In some cases, withholding may not apply, or it may be applied at a rate higher than the state’s minimum. In other cases, state income tax withholding may not be available. Refer to the State Income Tax Withholding Information sheet and Form IA W-4P and Instructions for details.</p>
  <p>While Schwab makes every effort to obtain reliable information about state tax laws, Schwab cannot guarantee the accuracy or timeliness of state tax withholding information. We recommend that you contact your tax advisor regarding your tax withholding election and to answer any questions you may have.</p>
  <p>One of the state income tax withholding elections has been made on your behalf by your financial advisor. You may approve the election or contact your financial advisor to change your state income tax withholding election.</p>
  <ul>
  <li>No state income tax withholding. I do not have any pension or annuity income subject to Iowa income tax  . (Note: Withholding is not required for a retirement or IRA distribution to qualifying individuals who are 55 years of age or older, disabled, or a surviving spouse of an individual who would have qualified.)</li>
  <li>State income tax withholding applied at a rate that meets or exceeds Iowa’s minimum tax rate</li>
  </ul>
  <p>Declaration: I, the undersigned, declare under penalties of perjury or false certificate, that I have examined this document, and, to the best of my knowledge and belief, it is true, correct, and complete.</p>
  <p>If no election had been made and no prior election request was on file, Schwab would apply withholding (if required) at the minimum rate based on the laws for your state of residency, as determined by your legal address of record on your account.</p>
  <p><b>Important Information About Your Distribution</b></p>
  <p><b>Reason for Distribution</b></p>
  <p>The distribution reason you provide your IA is required for IRS reporting purposes. If you authorize your IA to enter distributions on your behalf, you represent that you have authorized the distribution reason and that distribution reason will apply to future distributions, unless you change it by notifying your IA or Schwab.</p>
  <p><b>Normal Distribution or Required Minimum Distribution (RMD) (7)</b></p>
  <p>Use for any of the following when the taxpayer is 59&frac12; or older: Normal Distribution (including Required Minimum Distribution [RMD] when the taxpayer is RMD age), or for a distribution that will be rolled over to another IRA or an Employer Plan* within 60 days when the taxpayer is age 59&frac12; or older, or a Roth IRA conversion. </p>
  <p><b>Early Distribution (subject to 10% early withdrawal penalty) (1)</b></p>
  <p>Use for a distribution when the taxpayer has not reached age 59&frac12; including a distribution for qualified higher education expenses, qualified first-time home purchase, certain medical expenses, certain health insurance expenses, a qualified reservist distribution  , rollover to another IRA or an Employer Plan* within 60 days.</p>
  <p><b>Early Distribution (not subject to 10% early withdrawal penalty) (2)</b></p>
  <p>Use for the following distributions when the taxpayer has not reached age 59&frac12; and a substantially equal periodic payment exception under Section 72(t) applies    or for a Roth IRA conversion.</p>
  <p><b>Disability Distribution, under age 59&frac12; (3)</b></p>
  <p>Use for a distribution due to a disability under Section 72(m)(7).</p>
  <p><b>Distribution from an Inherited IRA (4)</b></p>
  <p>Use only for distributions from an Inherited IRA. To request an initial transfer of assets from a deceased account holder's IRA, please use the Inherited IRA Distribution Election Pdf.</p>
  <p><b>Direct Rollover Distribution to an Employer Plan* (G)</b></p>
  <p>This option is not available for Inherited IRAs or for IRA-to-IRA movement of money. Use only for a rollover to an Employer Plan*.</p>
  <p><b>Early Distribution from a SIMPLE IRA (subject to 25% early withdrawal penalty) (S)</b></p>
  <p>Use Code S only if the distribution is from a SIMPLE IRA in the first 2 years, the employee/taxpayer has not reached age 59&frac12; , and none of the exceptions under section 72(t) are known to apply when the distribution is made. The 2-year period begins on the day contributions are first deposited in the individual's SIMPLE IRA. Do not use Code S if Code 3 or 4 applies.</p>
  <p><b>Early Distribution from a Roth SIMPLE IRA (earnings subject to 25% early withdrawal penalty) (JS)</b></p>
  <p>Use for a distribution from a Roth SIMPLE IRA taken within two years of the date the first contribution was made if the taxpayer has not reached age 59&frac12;, and none of the exceptions under section 72(t) are known to apply when the distribution is made.</p>
  <p><b>Conversion to a Roth IRA (CONV-2 or CONV-7)</b></p>
  <p>Use for a Roth IRA conversion.</p>
  <p><b>Roth IRA Distribution (Q)</b></p>
  <p>Use for a distribution if the five-year holding period has been completed and the taxpayer has reached 59&frac12; or is disabled.</p>
  <p><b>Roth IRA Distribution (T)</b></p>
  <p>Use for a distribution if it is not known if the five-year holding period has been completed and the taxpayer has reached 59&frac12;, or the taxpayer is disabled, or for a distribution from an Inherited Roth IRA.</p>
  <p><b>Roth IRA Early Distribution (earnings subject to 10% early withdrawal penalty) (J)</b></p>
  <p>Use for a distribution when the taxpayer has not reached age 59&frac12; and no known exception under Section 72(t) applies. Distributions from Inherited Roth IRAs are not eligible.</p>
  <p><b>Qualified Charitable Distribution (7-QCD or Y4)</b></p>
  <p>Use for a distribution from an IRA or an Inherited IRA and the taxpayer has reached 70&frac12; and attests that it is a Qualified Charitable Distribution. Starting in 2026, 7-QCD will display as Y7 on the 1099-R.</p>
  <p><b>ESA Distribution</b></p>
  <p>Use for a distribution from an Education Savings Account.</p>
  <p><b>Withdrawal of Excess Contribution (Current or Prior Year) (8 or P)</b></p>
  <p><b>Distribution Pursuant to Death</b></p>
  <p>Use the Inherited IRA Distribution Election Pdf for an initial distribution due to death of the account holder. Call your investment advisor for the additional documentation required.</p>
  <p><b>Transfer Pursuant to Divorce</b></p>
  <p>Use for transfers of interest from IRA or ESA account holder to former spouse under a divorce or separation instrument Call your investment advisor for the additional documentation required.</p>
  <p>*"Employer plan" means a qualified retirement plan, a 403(b) annuity or Custodial account, or a 457(b) eligible deferred compensation plan maintained by a state or any political subdivision, agency or instrumentality thereof.</p>
  <p><b>Withdrawal of Assets</b></p>
  <p>You may take a distribution of assets - funds or securities - from a Traditional/Rollover IRA, Roth IRA, Inherited IRA, Inherited Roth IRA, SEP IRA, Roth SIMPLE IRA, or Traditional SIMPLE IRA at any time.</p>
  <p><b>Taxation of IRAs</b></p>
  <p>In general, qualified withdrawals from a Roth or Roth SIMPLE IRA (including contributions and investment earnings) and distributions of the nondeductible contributions to a Traditional/Rollover IRA, Roth IRA and Roth SIMPLE IRA are free from federal income tax. All other IRA distributions, including deductible contributions and investment earnings, are subject to federal (and possibly state) income tax at ordinary income tax rates. For more information, see IRS Publication 590 or consult a tax advisor.</p>
  <p><b>Rollover Exception</b></p>
  <p>If you make a withdrawal from your IRA, you have 60 days from the date you receive the withdrawal to roll the same assets back into an IRA (at Schwab or elsewhere) in order to avoid taxes and penalties on the amount withdrawn. The rollover must be made into the same kind of IRA (e.g., a distribution from a Roth IRA may be rolled over only into another Roth IRA, not a Traditional IRA). You may only do this once in a rolling 12-month period. Rollovers are not allowed with Inherited IRAs; therefore, the 60-day rollover rule does not apply.</p>
  <p><b>Early Withdrawal Penalty</b></p>
  <p>If you are not yet age 59&frac12;, a 10% early withdrawal penalty applies to the taxable portion of distributions from the Traditional/Rollover IRA, Roth IRA, SEP IRA, Roth SIMPLE IRA, or Traditional SIMPLE IRA unless the distribution qualifies for an exception to the penalty. In the case of a Roth SIMPLE or Traditional SIMPLE IRA, the early withdrawal penalty increases from 10% to 25% for a distribution made within the first two years after the account is funded.</p>
  <p><b>Exceptions to the Early Withdrawal Penalty</b></p>
  <p>The 10% penalty described above will not apply if the distribution is:</p>
  <ol>
  <li>used for qualified higher education expenses, qualified first-time home purchase, certain medical expenses, or certain health insurance expenses during periods when you are unemployed;</li>
  <li>made after your death or disability;</li>
  <li>paid in substantially equal payments over your life or life expectancy;</li>
  <li>paid on account of an IRS levy;</li>
  <li>a qualified reservist distribution;</li>
  <li>a qualified birth/adoption distribution;</li>
  <li>qualified disaster recovery distribution;</li>
  <li>distributions due to terminal illness;</li>
  <li>qualified distributions to victims of domestic abuse; or</li>
  <li>eligible emergency expense.</li>
  </ol>
  <p>You can file IRS Form 5329, along with your federal tax return, to claim an exemption from the 10% penalty with respect to your distribution.</p>
  <p>If you convert your Traditional/Rollover IRA to a Roth IRA, the taxable portion of your Traditional IRA is not subject to the 10% penalty regardless of your age at the time of the conversion.</p>
  <p><b>Repayment of Certain Penalty Free Distributions</b></p>
  <p>For qualified distributions of birth/adoption, federally declared disaster, terminal illness, domestic abuse or emergency expense distributions you have three years to repay the distribution. Generally, the three year timeframe starts the day after the distribution is received.</p>
  <p><b>Withdrawal of Excess Contributions</b></p>
  <p>If you withdraw an excess contribution, you are  required to file IRS Form 5329 with your tax return. Please see the "Penalty and Tax Reporting" section of the Charles Schwab & Co., Inc. Individual Retirement Disclosure Statement regarding taxation of excess contributions.</p>
  <p><b>Required Minimum Distributions</b></p>
  <p>When you reach RMD age, you are required to begin taking distributions from your Traditional/Rollover IRA. This is not required for a Roth IRA or Roth SIMPLE IRA. Inherited IRAs, including Roth Inherited IRAs, have different RMD rules. For more information, consult your investment advisor or IRS Publication 590.</p>
  <p><b>Taxation of Education Savings Accounts</b></p>
  <p>In general, withdrawals from an ESA are free from federal income tax if they are not more than the beneficiary's qualified education expenses for the year. All other ESA distributions are taxable, but only on the amount that represents earnings that have accumulated in the ESA. For more information, see IRS Publication 970 or consult a tax advisor.</p>
  <p><b>Rollover Exception ESA</b></p>
  <p>If you make a withdrawal from your ESA, you have 60 days from the date of the withdrawal to roll the same assets back into an ESA (at Schwab or elsewhere) for the same beneficiary (or a member of his or her family who has not reached age 30) in order to avoid taxes and penalties on the amount withdrawn. You may only do this once in a rolling 12-month period.</p>
  <p><b>Additional Tax</b></p>
  <p>An additional tax will generally apply to a taxable distribution from an ESA unless it is made:</p>
  <ol>
  <li>to the estate of a deceased beneficiary,</li>
  <li>on account of the beneficiary's disability,</li>
  <li>because of attendance at a U.S. military academy,</li>
  <li>as a refund of an excess contribution (and earnings) made before the beginning of the sixth month after the year of the contribution.</li>
  </ol>
  <p>If the additional tax applies, you are required to file IRS Form 5329 with your federal tax return.</p>
  <p><b>Custodial IRA</b></p>
  <p>If this is a Custodial IRA, you acknowledge and agree that any funds or securities transferred out of the account, and into the account of the custodian or other account, shall be used or applied solely for the benefit of the minor. </p>
  <p><b>Disbursement Authorization.</b></p>
  <p>If you have indicated on this form that your IA and/or TAMP will have disbursement authority over your account, you authorize Schwab to accept instructions from your IA and/or TAMP to transfer funds from your Schwab IRA or ESA account to the account at another financial institution designated above, and, if your account is an IRA account, to enter distribution reasons for your account. IA's and/or TAMP’s authority includes giving Schwab instructions on your behalf and changing existing instructions for one-time (on-request) transfers and recurring transfers and stopping transfers. IA's and/or TAMP’s authority does not include requesting disbursements to other Schwab accounts or other financial institution accounts not identified above. If your account is an IRA, IA's and/or TAMP’s authority also includes relaying your distribution instructions to Schwab, including entering distribution reasons for your IRA account.</p>
  <p><b>Termination of Authorizations (if applicable).</b></p>
  <p>The IA and/or TAMP authorization you have granted in this form will remain effective until you or IA have revoked or terminated it by giving notice to Schwab, either by mail, telephone, facsimile, telegraph, messenger, electronic mail, voice mail or otherwise, provided, however, that Schwab reserves the right to require written notice or confirmation that such authorization has been terminated or revoked. You understand that you may revoke or terminate the authorization conferred herein at any time. Unless revoked or terminated by you or IA and/or TAMP, authorization conferred herein to IA and/or TAMP shall continue to apply to IA's and/or TAMP ‘s successors or assigns. Such revocation will not affect your obligation resulting from transactions initiated prior to Schwab's receipt of such notice. You understand that if Schwab terminates its service agreement with IA and/or TAMP, Schwab will not be obligated to honor any further instructions from IA and/or TAMP; you will have exclusive control over, and responsibility for, your account; and unless Schwab notifies you otherwise, your account will become a Schwab retail IRA or ESA account subject to all terms and conditions applicable thereto, including fees and commissions for investment products and other services available to Schwab retail customers. Schwab will notify you as soon as reasonably possible after any such termination.</p>
  <p><b>Indemnification for Authorizations</b> (if applicable).</p>
  <p>You agree to indemnify and hold harmless Schwab, its affiliates, and their directors, officers, employees, and agents from and against all claims, actions, costs, and liabilities, including attorneys' fees arising out of or relating to (1) their reliance on authorizations granted in this form and (2) Schwab's execution of IA's and/or TAMP's instructions.</p>
  <p><b>IMPORTANT DISCLAIMER: This summary is intended to provide a general statement of the rules affecting withdrawals from IRAs and Education Savings Accounts and is not intended to provide specific guidance. The rules affecting withdrawals from these accounts are complex and subject to change. Please consult your own financial, tax or legal advisor regarding the application of the rules regarding your particular situation before requesting a distribution.  For more information see IRS Publication 590-B.</b></p>
  <p>I certify under penalty of perjury that (1) the number shown on this account is my correct taxpayer identification number; (2) I am not subject to backup withholding because (a) I am exempt from backup withholding, or (b) I have not been notified by the Internal Revenue Service (IRS) that I am subject to backup withholding as a result of a failure to report all interest and dividends, or (c) the IRS has notified me that I am no longer subject to backup withholding; and (3) I am a U.S. person (including a U.S. resident alien). I understand that if I have been notified by the IRS that I am subject to backup withholding as a result of dividend or interest underreporting and I have not received a notice from the IRS advising me that backup withholding is terminated, I must strike or cross out the information contained in Item 2 above. The IRS does not require my consent to any provision of this document other than the certifications required to avoid backup withholding.</p>
  <p>I certify and agree to the Tax Withholding Election selected above.</p>
  <p>Please distribute cash and/or securities from the IRA or ESA in the manner and for the reasons stated above. I certify that the information on this form is correct. Schwab may rely on my certification without further investigation or inquiry.</p>
  <p>(0326-YX81)</p>`;

export const submitAndCreateWarnings = {
  submitSuccessCreateFail:
    'Warning - We were unable to submit the SLOA at this time, but the Wire transaction has been successfully submitted - please resubmit only the SLOA request',
  submitFailCreateSuccess:
    'Warning - We were unable to submit the Wire Request at this time, but the SLOA has been successfully created - please resubmit only the Wire request',
  //The following is only used when ATP timeout is returned on the Submit wire step
  submitFailCreateSuccessForReleaseStep:
    'Warning - We were unable to release the Wire Request at this time, but the SLOA has been successfully created - please release the Wire request again'
};

export const confirmationPageButtons = {
  viewTransactionStatus: 'View transaction status',
  createAnotherTransaction: 'Create another transaction',
  viewInR: 'View Initiate & Release',
  initiateAnotherTransaction: 'Initiate another transaction',
  releaseAnotherTransaction: 'Release Another Transaction',
  returnToAccountStatus: 'Return to account status',
  printAuthForm: 'Printable Authorization Form',
  printPdfAuthForm: 'Print PDF authorization form',
  returnToAccountStatusD2P: 'Return to Account Status'

};

export const submitAndCreateConfirmationMessages = {
  eauthNeeded: 'We sent an eAuthorization notification to your client(s) to approve in Schwab Alliance—and if they need to enroll, we included instructions. We\'ll continue processing this transaction and the standing authorization once we’ve received client authorization.',
  loaNeeded: 'Please upload a signed authorization through Docusign. We\'ll continue processing this transaction and the standing authorization once we’ve received client authorization.',
  submitSuccessCreateFail: 'We were unable to submit the standing authorization due to a system error, but the Wire transaction has been successfully submitted. Please resubmit only the standing authorization request.',
  submitFailCreateSuccess: 'We were unable to submit the wire request due to a system error, but the standing authorization has been successfully created. Please resubmit only the wire request.',
};

export const isoInputFieldErrorMap = (displayName: string, maxlength: number) => {
  return {
    required: `${displayName} is required.`,
    pattern: 'Characters allowed are A-Z, 0-9 and \/-?:()\.,\'+ !#$%&*=^_`\\{|}~";<>@[]+',
    maxlength: `Please stay within ${maxlength} characters.`,
    firstCharAlphaNumeric: 'First character must be A-Z, 0-9.'
  };
};

export const isoInputZipErrorMap = (displayName: string, maxlength: number) => {
  return {
    required: `${displayName} is required.`,
    pattern: 'ZIP code must be numeric and can be entered as either \'12345\' or \'12345-1234\'',
    maxlength: `Please stay within ${maxlength} characters.`
  };
};

export type cancelModalSourceTypes
  = | ''
    | 'transactionTableViewStatus'
    | 'transactionTableEdit'
    | 'transactionTableStartTransaction'
    | 'transactionTableView'
    | 'StandingAuthTableStartTransaction'
    | 'StandingAuthTableViewDetails'
    | 'StandingAuthTableEdit'
    | 'accountHeaderActionsDropdown'
    | 'mainNavRedirect'
    | 'moveMoneyNavBarRedirect'
    | 'standingAuthReviewPage'
    | 'standingAuthInputPage'
    | 'transactionInputPage'
    | 'transactionReviewPage'
    | 'editTweModalInputPage'
    | 'editTweModalReviewPage';

export const formType = {
  //Wire FormType
  formTypeWire: 'oneTimeWire',
  formTypeCreateSloaWire: 'createSLOAWire',
  formTypeEditWire: 'editWire',
  formTypeRequestWire: 'Request Wire Using Bundled SLOA',
  formTypeReturnOTWire: 'One Time Wire',
  formTypeReturnWireSloaSetup: 'Wire SLOA Setup',
  formTypeReturnWireBSLOASetup: 'Wire BSLOA Setup',
  formTypeReturnOnReqWire: 'On Request Wire',
  formTypeReturnWire: 'Wire',

  //Journal FormType
  formTypeJournal: 'oneTimeJournal',
  formTypeRecJournal: 'recurringJournal',
  formTypeCreateSloaJournal: 'createSLOAJournal',
  formTypeReturnOnReqJournal: 'On Request Internal transfer',
  formTypeReturnOTJournal: 'One Time Internal transfer',
  formTypeReturnRecJournal: 'Recurring Internal transfer',
  formTypeReturnJournalSloaSetup: 'Internal transfer SLOA Setup',
  formTypeReturnJournalBSLOASetup: 'Internal transfer BSLOA Setup',

  //Check FormType
  formTypeCheck: 'onetimeCheck',
  formTypeRecCheck: 'recurringCheck',
  formTypeCheckSloa: 'CheckSloa',
  formTypeSloaCheck: 'SLOACheck',
  formTypeReturnOnReqCheck: 'On Request Check',
  formTypeReturnOTCheck: 'One Time Check',
  formTypeReturnRecCheck: 'Recurring Check',
  formTypeReturnCheckSloaSetup: 'Check SLOA Setup',
  formTypeReturnCheckBSLOASetup: 'Check BSLOA Setup',
};

export const logoSvg = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="300 200 300 200" preserveAspectRatio="xMaxYMax" style="height: 100px;">
        <style type="text/css">
        	.st0{fill:#009DDB;}
        	.st1{fill:#FFFFFF;}
        </style>
        <g>
        	<rect x="324" y="234" class="st0" width="144" height="144"/>
        	<g>
        		<g>
        			<path class="st1" d="M449.1,299.2c0-2-1.2-3.6-2.3-5c-0.9-1.2-1.8-2.4-1.8-3.6c0-1.6,0.9-2.6,2.3-2.6c0.7,0,1.3,0.3,1.8,0.5
        				c0.6,0.3,1.2,0.5,1.9,0.5c1,0,1.8-1,1.8-1.9c0-1-1-2-2.8-2c-4,0-7.6,4.6-7.6,8.2c0,2,1.2,3.5,2.2,4.8c0.8,1.1,1.6,2,1.6,3
        				c0,1.6-1.5,2.6-2.9,2.6c-1.4,0-2.4-0.9-3.2-1.6c-0.6-0.5-1.1-1-1.7-1c-0.8,0-1,1.6-1,2.2c0,0.9,1.9,2.5,4.1,2.5
        				C444.9,305.8,449.1,302.7,449.1,299.2"/>
        		</g>
        		<g>
        			<path class="st1" d="M361.3,273.9c-0.1,0-0.2,0.1-0.2,0.2v1c0,0.1,0,0.1,0.1,0.2c0,0,0.6,0.1,0.6,0.1l0.8,0.1
        				c1,0.2,1.2,0.3,1.2,0.8c0,0.8-0.9,3.4-2.2,7l-1.1,3.2c-1,2.9-2.5,6.8-3.9,10.4c-1.6,4.2-2.9,7.5-2.9,8c0,0.5,0.3,0.7,1.5,0.7
        				c1.3,0,1.9-0.2,2-0.7c2.3-7.4,8.5-15.9,11.7-15.9c1,0,1.4,0.4,1.4,1.4c0,1.7-1.4,4.8-2.8,7.8c-1.2,2.6-2.3,5.1-2.3,6.3
        				c0,1.1,0.5,1.6,1.5,1.6c3.2,0,5.6-2.9,7.5-5.2l0.3-0.3l0,0c0,0,0-0.1,0-0.1l-0.1-0.1c0,0-0.7-0.8-0.7-0.8c0,0,0,0-0.1-0.1
        				c0,0-0.1,0-0.1,0c-1.1,1.1-2.9,2.9-3.4,2.9c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.5c0-0.2,0.4-1.1,0.8-2.2
        				c1.2-2.9,3.2-7.8,3.2-10.7c0-2.3-1.1-3.6-3-3.6c-3.9,0-7,4.4-8.5,6.6c-0.3,0.5-0.7,1-0.8,1c0,0,0,0-0.1,0
        				c-0.1-0.1,0.2-0.6,0.5-1.5c0.4-1,1.1-2.5,1.9-4.7c2.9-7.6,4.2-11.7,4.2-12c0-0.5-0.4-0.5-0.8-0.5H361.3z"/>
        		</g>
        		<g>
        			<path class="st1" d="M352.7,301.1c0,0,0-0.1,0-0.2c0,0-0.7-0.7-0.7-0.7c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0.1
        				c-1.2,1.1-3.5,3-5.6,3.2c-0.8,0.1-1.6-0.2-2.1-0.7c-0.7-0.6-1.1-1.6-1.2-2.8c-0.1-3.1,2.5-7.9,5.2-10.7c1.4-1.5,2.7-2.3,3.7-2.3
        				c1.1,0,1.8,0.8,2.5,1.6c0.6,0.7,1.1,1.4,1.9,1.4c0.3,0,0.6-0.2,0.9-0.4c0.3-0.3,0.4-0.7,0.4-1.1c-0.1-1.2-1.2-3.2-4-3.2
        				c-3.2-0.1-7.2,1.9-10.2,5c-2.8,2.9-4.3,6.4-4.2,9.8c0.1,2.8,1.6,5.9,5.6,5.9C348.6,305.8,352.1,302.3,352.7,301.1L352.7,301.1z"
        				/>
        		</g>
        		<g>
        			<path class="st1" d="M404.5,293.9c-0.1,0.2-0.3,0.6-0.4,0.6c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1c0-0.2,0.2-1,0.5-2.1
        				c0.5-2,1.1-4.7,1.1-5.5c0-1-0.6-1.6-1.6-1.6c-2.1,0-5.3,3.5-6.4,5.4c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1l0,0l0.6,0.7
        				c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.1-0.1c0,0,0.2-0.2,0.2-0.2c0,0,0.2-0.2,0.2-0.2c0.7-0.9,2.2-2.8,3-2.8c0.4,0,0.7,0.4,0.7,1.2
        				c0,1.9-2.1,7.6-3.4,11.4c-0.8,2.1-1.3,3.7-1.3,4c0,0.4,0.2,0.6,0.5,0.6h1.8c0.4,0,0.5-0.2,0.7-0.8c0,0,0.9-2.1,1.4-3.1
        				c3.5-7.2,5.5-10.9,6.9-12.3c1-1,1.7-1.4,2.2-1.4c0.4,0,0.6,0.3,0.9,0.6c0.3,0.3,0.6,0.7,1.1,0.7c0.4,0,0.7-0.1,1-0.4
        				c0.4-0.4,0.7-1.1,0.7-1.9c0-1.3-0.9-1.8-1.7-1.8C410.1,285.2,407.7,287.6,404.5,293.9z"/>
        		</g>
        		<path class="st1" d="M393.4,284.8c-0.3,0.1-0.4,0.3-0.6,0.6c-0.2,0.3-0.4,0.6-0.7,0.6c-0.3,0-0.6-0.1-0.9-0.1
        			c-0.5-0.1-1.1-0.2-1.9-0.2c-8.9,0-13.6,12-13.6,16.1c0,2.8,1.5,4.1,3.1,4.1c1.9,0,4.5-0.6,7.8-5.7c0,0,0.7-1.2,0.8-1.2
        			c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.2l-0.3,0.6c-0.4,0.9-1.2,2.5-1.2,4.1c0,0.7,0.2,1.3,0.5,1.6c0.3,0.3,0.7,0.4,1.3,0.4
        			c3.1-0.1,5.8-4,6.8-5.5c0,0,0-0.1,0-0.1l0-0.1l-0.7-0.8c-0.1-0.1-0.2-0.1-0.2,0l-0.7,0.8c-0.9,1.1-2.1,2.6-2.7,2.6
        			c-0.2,0-0.3,0-0.3-0.1c-0.1-0.1-0.1-0.3-0.1-0.6c0.1-1,1.9-5.9,3.4-9.9c1.1-2.9,2.1-5.5,2.1-5.9c0-0.1,0-0.4-0.3-0.5h0l-1.2-0.8
        			c0,0-0.1,0-0.1,0C393.7,284.9,393.6,284.8,393.4,284.8z M379.3,300.8c0-5.8,4.6-13.9,9.2-13.9c1.5,0,2.4,0.9,2.4,2.4
        			c0,2.4-6.3,13.4-10.2,13.4C379.8,302.8,379.3,302.4,379.3,300.8z"/>
        		<path class="st1" d="M422.4,300.2c0,3.3,2.2,5.6,5.3,5.6c3.7,0,7.5-3.5,8.4-4.7c0-0.1,0-0.1,0-0.2l0,0l-0.6-0.7
        			c-0.1-0.1-0.2-0.1-0.2,0l-0.5,0.4c-1.2,0.9-3.4,2.6-5.1,2.6c-2,0-3.3-1.3-3.3-3.4c0-2.5,1.2-4.4,2.2-5.8c0,0,0.1-0.1,0.1-0.2
        			c0,0,0.3,0,0.3,0l1.9,0.1c3.3,0,9.5-1.6,9.5-5.4c0-1.6-1.5-3.2-4.1-3.2C430.6,285.2,422.4,293,422.4,300.2z M435.6,286.5
        			c1,0,1.7,0.7,1.7,1.7c0,2.5-2.8,3.9-7.8,4C430.5,290.5,433.2,286.5,435.6,286.5z"/>
        		<g>
        			<path class="st1" d="M420.8,300.4c0.1-0.1,0-0.2,0-0.2c0,0-0.7-0.9-0.7-0.9c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1,0.1l-0.2,0.3
        				c-1.7,1.9-2.7,3-3.5,3c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.3-0.2-0.6c0-1.1,1.8-6.1,5.3-15.3l2.6-6.6c1.3-3.5,2-5.2,2-5.4
        				c0-0.1,0-0.3-0.1-0.4c-0.1-0.1-0.4-0.2-0.7-0.2h-6c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,1,0,1c0,0.1,0,0.1,0.1,0.2c0,0,1.3,0.1,1.3,0.1
        				c0.9,0.1,1.2,0.4,1.2,1c0,0.8-3.9,10.4-3.9,10.4c-2.1,5.2-5.6,14.1-5.7,16.2c0,0.9,0.2,1.7,0.6,2.2c0.4,0.4,1,0.7,1.8,0.7
        				c2.4,0,4.9-3,6.5-5L420.8,300.4L420.8,300.4z M418.7,275.3L418.7,275.3L418.7,275.3L418.7,275.3z"/>
        		</g>
        		<g>
        			<path class="st1" d="M339.1,318.4c0,2.8,2.2,4.3,4.4,5.5l0.9,0.5c2.2,1.1,3.1,2.2,3.1,3.9c0,1.9-1.2,3.3-3,3.3
        				c-2.8,0-4.4-3-5.1-4.7l0,0l-1,0.3l0,0c0.3,1.8,0.6,3.7,0.9,4.5l0,0l0.5,0.2l1.3,0.4c0.8,0.3,1.9,0.5,2.9,0.5c3.9,0,6.7-2.4,6.7-6
        				c0-3.3-2.5-4.8-4.4-5.6l-0.7-0.3c-2.4-1.1-3.4-2.2-3.4-3.7c0-1.5,0.9-3,2.9-3c2.4,0,3.3,1.9,3.8,3.7l0,0l1-0.2l0-0.1
        				c-0.3-1.4-0.4-2.7-0.6-3.9l0,0l-0.7-0.2l-0.6-0.2c-0.7-0.3-1.7-0.4-2.7-0.4C341.7,312.8,339.1,315.1,339.1,318.4z"/>
        		</g>
        		<g>
        			<path class="st1" d="M352.7,323.1c0,4.8,3.3,9.6,10.8,9.6c1.9,0,4.4-0.6,5.5-0.9c0.5-1.2,1.2-3.6,1.5-4.9l0-0.1l-0.9-0.2l0,0
        				c-1.5,3-2.9,4.7-6.1,4.7c-4.1,0-6.9-3.7-6.9-9.1c0-3.8,1.8-8.2,6.9-8.2c3,0,4.6,1.3,5.4,4.3l0,0l0.9-0.1l-0.1-1.3l-0.4-3.4h0
        				l-0.5-0.1c-1-0.2-2.7-0.6-4.7-0.6C357.4,312.8,352.7,317.1,352.7,323.1z"/>
        		</g>
        		<g>
        			<path class="st1" d="M392.3,313.3H384v0.9l0,0c2.1,0.2,2.4,0.3,2.4,3.5c0,0,0,3.7,0,3.8c-0.1,0-8.7,0-8.8,0c0-0.1,0-3.8,0-3.8
        				c0-3.2,0.3-3.3,2.3-3.5l0.1,0v-0.9h-8.4v0.9l0,0c2.5,0.2,2.6,0.4,2.6,3.5v10.2c0,3.1-0.2,3.3-2.5,3.5l0,0v0.9h8.4v-0.9l0,0
        				c-2.2-0.2-2.5-0.3-2.5-3.5c0,0,0-4.8,0-4.9c0.1,0,8.7,0,8.8,0c0,0.1,0,4.9,0,4.9c0,3.1-0.2,3.3-2.6,3.5l0,0v0.9h8.5v-0.9l0,0
        				c-2.2-0.2-2.4-0.3-2.4-3.5v-10.2c0-3.1,0.2-3.3,2.5-3.5l0,0L392.3,313.3L392.3,313.3z"/>
        		</g>
        		<g>
        			<path class="st1" d="M421.4,313.3h-6.7v0.9l1.1,0.1c0.6,0,0.9,0.2,1,0.4c0.1,0.1,0.1,0.3,0.1,0.6c0,0.3-0.1,0.7-0.2,1.3
        				c-0.1,0.3-1.7,6.6-2.9,10.8c-0.2-0.6-5.1-13.8-5.1-13.8l0,0h-1.2c0,0-4.3,13.6-4.4,13.8c-0.2-0.6-3.4-11.3-3.4-11.3
        				c-0.1-0.4-0.2-0.7-0.2-1c0-0.2,0-0.3,0.1-0.4c0.2-0.2,0.5-0.3,1-0.4c0,0,0.9-0.1,0.9-0.1v0v-0.9h-8v0.9l0,0
        				c1.6,0.2,2,0.3,2.8,2.8l4.8,15.5h1.4c0,0,4.5-13.4,4.5-13.6c0.2,0.6,4.9,13.6,4.9,13.6l0,0h1.4l0,0c2.7-9,4.9-15.3,4.9-15.4
        				c1-2.7,1.2-2.8,3-2.9l0,0L421.4,313.3L421.4,313.3z M407.2,318.9L407.2,318.9L407.2,318.9z M413.8,327.4L413.8,327.4L413.8,327.4
        				z"/>
        		</g>
        		<path class="st1" d="M426.4,317.9c0,0.1,2.2,6.2,2.2,6.3c-0.1,0-4.4,0-4.5,0C424.2,324,426.4,317.9,426.4,317.9
        			C426.4,317.9,426.4,317.9,426.4,317.9z M430.1,318.4l-2-5.3l0,0l-1.2,0.1l-5.9,15.2c-1,2.6-1.3,2.7-3.1,2.9l0,0v0.9h6.6v-0.9
        			l-0.9-0.1c-0.6-0.1-1-0.2-1.1-0.4c-0.1-0.1-0.1-0.2-0.1-0.4c0-0.3,0.1-0.6,0.3-1.2l0.2-0.5c0.4-1.2,0.8-2.5,1.1-3.2
        			c0.1,0,5.3,0,5.3,0c0.6,1.6,1.3,3.3,1.6,4.1c0.1,0.4,0.2,0.6,0.2,0.9c0,0.1,0,0.2-0.1,0.3c-0.1,0.2-0.4,0.3-0.9,0.4l-0.9,0.1v0.9
        			h7.8v-0.9l0,0c-1.6-0.2-2-0.3-3-2.9L430.1,318.4z"/>
        		<path class="st1" d="M443.9,315.9c0-0.7,0-1.2,0.2-1.3c0.1,0,0.4-0.1,1.3-0.1c0.9,0,3.6,0.2,3.6,3.5c0,2.3-1.4,3.6-4,3.6
        			c0,0-1,0-1.1,0C443.9,321.5,443.9,315.9,443.9,315.9z M438.3,313.3L438.3,313.3l-0.1,0.9l0,0c2,0.2,2.3,0.3,2.3,3.5v10.2
        			c0,3.2-0.3,3.3-2.5,3.5l0,0v0.9h7.3c2.3,0,4.3-0.4,5.6-1.2c1.8-1.1,2.6-2.5,2.6-4.4c0-2.6-1.9-4.5-5.1-4.9c1.4-0.3,4-1.5,4-4.2
        			c0-1.5-0.5-2.6-1.7-3.3c-1.1-0.7-2.3-1-4.5-1H438.3z M444.8,322.7c3.2,0,5.1,1.6,5.1,4.3c0,3-2,4-3.8,4c-0.8,0-1.3-0.1-1.6-0.4
        			c-0.5-0.4-0.5-1.4-0.5-2.8c0,0,0-5,0-5.1C444,322.7,444.8,322.7,444.8,322.7z"/>
        	</g>
        </g>
        </svg>`;

export const activityReportDisclaimerText = ['The Move Money Activity Report provides a list of move money transactions and incoming ACH transactions for specific date and time of report.', 'It does not include recurring requests, other incoming or Schwab Bank requests.', 'Note: current business day reports are available after 1:00pm EST.'];

export const USCountryFullName = 'UNITED STATES';

export const svgIcons = {
  achReviewPageIncoming: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjMzMTQgNy45OTczOUMxLjMzMTQgMTEuNjc3NCA0LjMxODA3IDE0LjY2NDEgNy45OTgwNyAxNC42NjQxQzExLjY3ODEgMTQuNjY0MSAxNC42NjQ3IDExLjY3NzQgMTQuNjY0NyA3Ljk5NzRDMTQuNjY0NyA0LjMxNzQgMTEuNjc4MSAxLjMzMDczIDcuOTk4MDcgMS4zMzA3M0M0LjMxODA3IDEuMzMwNzMgMS4zMzE0IDQuMzE3MzkgMS4zMzE0IDcuOTk3MzlaTTkuMTI2ODggMTAuODYwNUM4Ljg2NTU2IDExLjA2MzQgOC40ODg3NCAxMS4wNDUgOC4yNDg0MiAxMC44MDUxQzguMDA4MTEgMTAuNTY1MyA3Ljk4ODA4IDEwLjE4NTUgOC4xODgzNSA5LjkyNTY1TDkuNDQzMzIgOC42NjY0MUw0LjY2NzU0IDguNjY2NTZMNC41ODk5NyA4LjY2MjA1QzQuMjU5MDEgOC42MjMzOSA0IDguMzQwNTYgNCA4LjAwMDI5QzQgNy42NjA1IDQuMjYwMzQgNy4zNzQwMSA0LjU4NzQ0IDcuMzQwNjlMNC42Njc1NCA3LjMzNDAzTDkuNDQzMzIgNy4zMzM4OEw4LjI0ODQzIDYuMTM0NjFMOC4xOTI5NCA2LjA3MTg4QzguMDA2MzUgNS44MzIyOSA4LjAwNTMzIDUuNDkzMzMgOC4xOTUwMiA1LjI1NTE0TDguMjQ4NDMgNS4xOTUxOEw4LjMxMTI3IDUuMTM5OEM4LjU1MTMyIDQuOTUzNTYgOC44OTA5MyA0Ljk1MjU0IDkuMTI5NTggNS4xNDE4N0w5LjE4OTY2IDUuMTk1MThMMTIgOC4wMDAxNUw5LjE4OTY2IDEwLjgwNTFMOS4xMjY4OCAxMC44NjA1WiIgZmlsbD0iIzJEODYyRCIvPgo8L3N2Zz4K',
  achReviewPageOutgoing: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xLjMzMTQgNy45OTczOUMxLjMzMTQgMTEuNjc3NCA0LjMxODA3IDE0LjY2NDEgNy45OTgwNyAxNC42NjQxQzExLjY3ODEgMTQuNjY0MSAxNC42NjQ3IDExLjY3NzQgMTQuNjY0NyA3Ljk5NzRDMTQuNjY0NyA0LjMxNzQgMTEuNjc4MSAxLjMzMDczIDcuOTk4MDcgMS4zMzA3M0M0LjMxODA3IDEuMzMwNzMgMS4zMzE0IDQuMzE3MzkgMS4zMzE0IDcuOTk3MzlaTTkuMTI2ODggMTAuODYwNUM4Ljg2NTU2IDExLjA2MzQgOC40ODg3NCAxMS4wNDUgOC4yNDg0MiAxMC44MDUxQzguMDA4MTEgMTAuNTY1MyA3Ljk4ODA4IDEwLjE4NTUgOC4xODgzNSA5LjkyNTY1TDkuNDQzMzIgOC42NjY0MUw0LjY2NzU0IDguNjY2NTZMNC41ODk5NyA4LjY2MjA1QzQuMjU5MDEgOC42MjMzOSA0IDguMzQwNTYgNCA4LjAwMDI5QzQgNy42NjA1IDQuMjYwMzQgNy4zNzQwMSA0LjU4NzQ0IDcuMzQwNjlMNC42Njc1NCA3LjMzNDAzTDkuNDQzMzIgNy4zMzM4OEw4LjI0ODQzIDYuMTM0NjFMOC4xOTI5NCA2LjA3MTg4QzguMDA2MzUgNS44MzIyOSA4LjAwNTMzIDUuNDkzMzMgOC4xOTUwMiA1LjI1NTE0TDguMjQ4NDMgNS4xOTUxOEw4LjMxMTI3IDUuMTM5OEM4LjU1MTMyIDQuOTUzNTYgOC44OTA5MyA0Ljk1MjU0IDkuMTI5NTggNS4xNDE4N0w5LjE4OTY2IDUuMTk1MThMMTIgOC4wMDAxNUw5LjE4OTY2IDEwLjgwNTFMOS4xMjY4OCAxMC44NjA1WiIgZmlsbD0iI0MxMEIxNCIvPgo8L3N2Zz4K'
};
